import { Component, OnInit, HostListener, ViewChild, ViewEncapsulation } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import * as _ from 'lodash';
import * as stringify from 'json-stable-stringify';
import { SharedService } from 'app/shared/services/shared.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';
import { DemandService } from 'app/shared/services/demand.service';
import { HttpService } from 'app/shared/services/http.service';
import { ModalsService } from 'app/shared/services/modals.service';
import { UserService } from 'app/shared/services/user.service';
import { GridService } from 'app/shared/services/grid.service';
import { CampaignsService } from 'app/shared/services/campaigns.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';
import { CallbacksService } from 'app/shared/services/callbacks.service';
import { GridComponent } from 'app/shared/components/grid/grid.component';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { ListItem } from '../../../../types';
const FEATURES_PRESETS = {
  disableVPAID: {
    feature: 'rtb_extra',
    preset: {
      api: [],
      js: 0,
      mimes: ['video/mp4', 'video/mpeg', 'video/ogg', 'video/webm'],
    },
  },
};

const TYPE_DISPLAY = 'display';
const TYPE_VIDEO = 'video';

/** Prebid partner Xandr / AppNexus — see bidder list from API */
const APPNEXUS_PREBID_BIDDER_ID = 6;
const APPNEXUS_PB_BIDDER_NAME = 'appnexus';
const APPNEXUS_PBS_PLACEMENT_PARAM = 'placement_id';
const APPNEXUS_PBJS_PLACEMENT_PARAM = 'placementId';

/** Assertive Yield — Prebid Server only; partners come from AY stored imps, not bidder params */
const ASSERTIVE_YIELD_PREBID_BIDDER_ID = 149;

const EXCO_NETWORK_ID = 368531133;
const GOOGLE_PARTNER_ID = 74093;
const EXCO_GOOGLE_DEFAULT_FLOOR_CPM = 1;

const EXPERIMENTAL_FEATURES = {
  demandOwner: '',
  forceGPV: false,
  ivtb: false,
  vb: false,
  skipNext: false,
  dntssch: false,
  maxImp: null,
  maxReq: null,
  playCapInSlot: null,
  gapInSlot: null,
  priceFactor: null,
  disableGoogleMacros: false,
  /** Per-macro % of requests where the Google param is stripped (demand extra param). */
  googleMacroSuppression: null,
  slotTypeTargeting: { enable: false, list: [] },
  scho: { enabled: false, sid: '', asi: '' },
  scha: { enabled: false, sid: '', asi: '' },
  demandCap: { enabled: false, maxImpressions: 1 },
  disableVPAID: false,
  rtb_extra: {},
  pbserver: false,
  pbserverParams: {},
  /** AY stored imp id, sent by the player as imp.ext.prebid.storedrequest.id */
  pbsStoredRequestId: '',
  ignoreMLRecommendation: false,
  schainOem: { sid: '', domain: '' }, // feature for oem and not Exco
  plcmtOem: { plcmt: 0, placement: 0 }, // feature for oem and not Exco
  excludeMA: false,
  keepHardCoded: false,
  disableSkip: false,
  externalDynamicVast: false,
  takePriceFromNode: false,
  pbjsOptionalParams: {},
};

@AutoUnsubscribe()
@Component({
  selector: 'new-demand-component',
  templateUrl: './new-demand.component.html',
  styleUrls: ['./new-demand.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NewDemandComponent implements OnInit {
  public iasIncList: any[] = [];
  public iasExcList: any[] = [];
  public iasHighRisk: any[] = [];
  public allSections: Array<any>;
  public visibleSections: Array<any>;
  public activeSection: number;
  public editMode: boolean;
  public duplicateMode: boolean;
  public routeParams: any;
  public demandTypes: Array<any>;
  public eventsList: Array<any>;
  public partners: Array<any>;
  public demandOwnerTypes: Array<any> = [
    { label: 'Programmatic Demand', value: 'programmatic' },
    { label: 'Direct Demand', value: 'direct' },
    { label: 'House', value: 'house' },
  ];
  public newPartner: boolean;
  public demandData: any;
  public originalData: any;
  public getDemandResponse: any;
  public demandTypeName: string;
  @ViewChild('listAssigned') public assignedSupplyGrid: GridComponent;
  public assignedSupplyData: Array<any>;
  public assignedSupplyDataDisplayed: Array<any>;
  public assignedCampaignDataDisplayed: Array<any>;
  public assignedSupplyColumnsSettings: Array<any>;
  public assignedCampaignsColumnsSettings: Array<any>;
  public assignedSupplyTabsData: Array<any>;
  public assignedSupplySelectedTab: number;
  public assignedSupplyFilters: any;
  public assignedEntities: Array<any>;
  private indexedAssignedEntities: any;
  public assignOverrideSettings: any;
  public domainLists: Array<any>;
  public ipLists: Array<any>;
  public URLsList: Array<any>;
  public targeting: any;
  public originalTargetingDayFromHourList: Array<any>;
  public originalTargetingDayToHourList: Array<any>;
  public verifyNetworkForCedatoXLoading: boolean;
  public verifyNetworkForCedatoXConfirmed: boolean;
  public viewabilityPassOptions: Array<any>;
  public parentNetworkIdOnFocus: number;
  public errorInputs: Array<string>;
  public beErrors: any;
  public beErrorsArr: Array<string>;
  public newListItem: any;
  public isLoading: boolean;
  public isLoadingEntities: boolean;
  public isLoadingCampaigns: boolean;
  public isLoadingDomainLists: boolean;
  public isLoadingIPLists: boolean;
  public isLoadingURLsLists: boolean;
  public subscriptions: Array<Subscription>;
  private demandPartnersRefreshSub: Subscription;
  private demandPartnersRefreshTimeoutId: any;
  public mvrTmpStore: any;
  public isFreqCappingEnabled: boolean;
  public viewVars: any;
  public demandUrlValid: boolean;
  public demandUrlFormatted: string;
  public isCampaignFeatureEnabled: boolean;
  public customMVRCappingLimit: number;
  public bidder: any[];
  public bidderConf: any;
  public bidderDataError: boolean;
  public bidderDisabledPartner: string;
  private vastCpmTimer;
  public dynamicDemand: boolean;
  public pushPercentage: number;
  public maxDuration: number;
  public adSlotTargeting: boolean;
  public adSlotsTypes = [
    { value: 1, name: 'Player Preroll', code: 'playerStart', isNewItem: false },
    { value: 2, name: 'Braking Ads', code: 'breakingAds', isNewItem: false },
    { value: 3, name: 'Preroll', code: 'preRoll', isNewItem: false },
  ];
  public adSlotsTargetingList: any[] = [];
  public experimentalFeatures = JSON.parse(JSON.stringify(EXPERIMENTAL_FEATURES));
  public demandSubType: string;
  public googleSlotId: string;
  public googleSlotDimensions: string;
  public demandDisplayFallback: boolean;
  public googleKeyValueEnabled: boolean;
  public googleKeyValueParam: string;
  public prebidServerParams: { bidders: [{ bidder: string; id: number; params: any[] }] };
  private oemPrebidBiddersAllowed: string[];
  private oemPrebidBidders: any[];
  public placements: any;
  private selectedPlacement: { plcmt: number; placement: number };
  public schainDropDownValue: string;
  public schainDropDown: any[];
  public schainsForDropdown: any[];
  public isMaxImpActive: boolean;
  public isMaxReqActive: boolean;
  public isPlayCapInSlotActive: boolean;
  public isGapInSlotActive: boolean;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public sharedService: SharedService,
    public httpService: HttpService,
    public demandService: DemandService,
    public dictionaryService: DictionaryService,
    public modalsService: ModalsService,
    public userService: UserService,
    public gridService: GridService,
    public callbacksService: CallbacksService,
    public campaignsService: CampaignsService,
    public ga: GoogleAnalyticsService
  ) {
    this.iasIncList = this.sharedService.targetingLookups.iasIncludeList
      .filter((item) => item.name != null)
      .sort((a, b) => a.name.localeCompare(b.name));
    this.iasExcList = this.sharedService.targetingLookups.iasExcludeList
      .filter((item) => item.name !== null && !item.name.toLowerCase().includes('high risk'))
      .sort((a, b) => a.name.localeCompare(b.name));
    this.iasHighRisk = this.sharedService.targetingLookups.iasExcludeList.filter(
      (item) => item.name !== null && item.name.toLowerCase().includes('high risk')
    );
    this.allSections = _.cloneDeep(this.demandService.sideMenuSections);
    this.visibleSections = [];
    this.routeParams = {};
    this.demandData = {};
    this.originalData = {};
    this.activeSection = 0;
    this.editMode = false;
    this.duplicateMode = false;
    this.getDemandResponse = {};
    this.assignedSupplyData = [];
    this.assignedSupplyDataDisplayed = [];
    this.assignedCampaignDataDisplayed = [];
    this.assignedCampaignsColumnsSettings = [
      {
        key: 'b_active',
        label: 'LIVE',
        parseFunction: this.gridService.parseBoolean,
        parseTooltipFunction: this.gridService.parseLiveTooltip,
      },
      { key: 'b_id', label: 'CAMPAIGN_ID', width: 150, filterType: 'INPUT' },
      { key: 'b_name', label: 'CAMPAIGN_NAME', filterType: 'INPUT' },
      {
        key: 'b_running',
        label: 'IS_RUNNING',
        width: 100,
        filterType: 'SELECT',
        parseFunction: this.gridService.parseBoolean,
        parseTooltipFunction: this.gridService.parseRunningTooltip,
      },
      { key: 'b_hourly', label: 'HOURLY', width: 100, filterType: 'RANGE' },
      { key: 'b_daily', label: 'DAILY', width: 100, filterType: 'RANGE' },
      {
        key: 'b_start',
        label: 'START_DATE',
        width: 180,
        filterType: 'INPUT',
        parseFunction: this.gridService.parseDayTime,
        parseTooltipFunction: this.gridService.parseDayTime,
      },
      {
        key: 'b_end',
        label: 'END_DATE',
        width: 180,
        filterType: 'INPUT',
        parseFunction: this.gridService.parseDayTime,
        parseTooltipFunction: this.gridService.parseDayTime,
      },
    ];
    this.assignedSupplyColumnsSettings = [
      { key: '$$selected', label: 'ASSIGNED', width: 192, resizable: true },
      { key: 'active', label: 'ACTIVE' },
      { key: 'playerId', label: 'SUPPLY_ID', filterType: 'INPUT', primaryKey: true },
      { key: 'name', label: 'NAME', filterType: 'INPUT' },
      { key: 'partner', label: 'PARTNER_NAME', filterType: 'SELECT' },
      {
        key: 'type',
        label: 'TYPE',
        filterType: 'SELECT',
        parseFunction: this.gridService.parseSupplyType,
        parseTooltipFunction: this.gridService.parseSupplyType,
      },
    ];

    if (this.userService.isCedatoPublisherNetwork() || this.userService.getFeatureState('hb_type')) {
      this.assignedSupplyColumnsSettings = [
        ...this.assignedSupplyColumnsSettings,
        ...[
          {
            key: 'hb',
            label: 'HB_TYPE',
            filterType: 'SELECT',
            parseFunction: this.gridService.parseBooleanTooltip,
            parseTooltipFunction: this.gridService.parseBooleanTooltip,
          },
        ],
      ];
    }

    this.assignedSupplyColumnsSettings = [
      ...this.assignedSupplyColumnsSettings,
      ...[
        {
          key: 'environment',
          label: 'ENVIRONMENT_SHORT',
          filterType: 'SELECT',
          parseFunction: this.gridService.parseMultipleEnvironments,
          parseTooltipFunction: this.gridService.parseMultipleEnvironmentsTooltip,
        },
        { key: 'fixed_cost', label: 'FIXED_COST', rightAligned: true, filterType: 'RANGE', char: '$', align: 'left' },
        {
          key: 'revshare_cost',
          label: 'REVSHARE_COST',
          rightAligned: true,
          width: 200,
          filterType: 'RANGE',
          char: '%',
          align: 'right',
        },
        { key: 'domain_list_type', label: 'DOMAIN_LIST', parseFunction: this.gridService.parseListConditionType },
        { key: 'ip_list_type', label: 'IP_LIST', parseFunction: this.gridService.parseListConditionType },
        {
          key: 'limit_assign',
          label: 'LIMITED_ASSIGNMENT',
          filterType: 'SELECT',
          parseFunction: this.gridService.parseBooleanTooltip,
          parseTooltipFunction: this.gridService.parseBooleanTooltip,
          featureFlag: 'limit_assign',
        },
      ],
    ];

    this.assignedSupplyTabsData = [
      { title: this.dictionaryService.get('VIEW_ALL') },
      { title: this.dictionaryService.get('VIEW_ELIGIBLE') },
      { title: this.dictionaryService.get('VIEW_INELIGIBLE') },
    ];
    this.assignedSupplySelectedTab = 0;
    this.assignedSupplyFilters = { active: [true] };
    this.assignedEntities = [];
    this.bidder = [];
    this.bidderConf = {};
    this.bidderDataError = false;
    this.bidderDisabledPartner = null;
    this.updateIndexedAssignedEntities();
    this.assignOverrideSettings = {
      enabled: true,
      state: false,
      label: this.dictionaryService.get('ALLOW_TO_ASSIGN_LIMITED_ASSIGNMENT_SUPPLY'),
    };
    this.targeting = {
      iasTargeting: false,
      iasAvoidance: false,
      highRiskAvoidance: false,
      location: false,
      browsers: false,
      os: false,
      targetingSizes: false,
      vastDomains: false,
      dma: false,
      timeTargeting: false,
      state: false,
      schains: false,
    };
    // Build day targeting hours drop down values
    this.originalTargetingDayFromHourList = _.cloneDeep(this.sharedService.targetingLookups.hours12Format);
    this.originalTargetingDayToHourList = [];
    for (let hourIndex = 1; hourIndex <= this.sharedService.targetingLookups.hours12Format.length; hourIndex++) {
      this.originalTargetingDayToHourList.push(
        _.cloneDeep(this.sharedService.targetingLookups.hours12Format)[hourIndex % 24]
      );
    }
    this.verifyNetworkForCedatoXLoading = false;
    this.verifyNetworkForCedatoXConfirmed = false;
    this.viewabilityPassOptions = [
      { label: this.dictionaryService.get('VIEWABILITY_PASS'), value: 1 },
      { label: this.dictionaryService.get('VIEWABILITY_BLOCK'), value: 0 },
    ];
    this.errorInputs = [];
    this.beErrors = {};
    this.beErrorsArr = [];
    this.newListItem = {
      label: '+ ' + dictionaryService.get('NEW_LIST'),
      link: '/list/new',
    };
    this.isLoading = false;
    this.isLoadingEntities = false;
    this.isLoadingCampaigns = false;
    this.isLoadingDomainLists = false;
    this.isLoadingIPLists = false;
    this.isLoadingURLsLists = false;
    this.subscriptions = [];
    this.viewVars = {
      isCappingUserFreq: this.userService.getFeatureState('vast_capping_freq_user'),
      isCappingIPFreq: this.userService.getFeatureState('vast_capping_freq_ip'),
    };
    this.mvrTmpStore = {
      user_mvr: null,
      custom_user_mvr: null,
      isChanged: false,
    };
    this.isFreqCappingEnabled = false;
    this.subscriptions.push(
      this.sharedService.getMessagesBus().subscribe((response: any) => {
        if (response.type === 'CEDATOX_CONFIRM') {
          this.verifyNetworkForCedatoXConfirmed = response.data;
          if (!this.verifyNetworkForCedatoXConfirmed) {
            this.demandData.parentNetworkId = '';
            this.demandData.parentNetworkName = '';
          }
        } else if (response.type === 'NETWORK_CHANGE') {
          this.errorInputs = [];
          this.beErrors = {};
          this.beErrorsArr = [];
          if (!this.editMode) {
            this.isLoading = true;
            this.assignedSupplyData = [];
            this.assignedSupplyDataDisplayed = [];
            this.assignedCampaignDataDisplayed = [];
            this.ipLists = [];
            this.domainLists = [];
            this.URLsList = [];
          }
        } else if (response.type === 'FORM_ERROR_HIDE') {
          _.without(this.errorInputs, response.data);
        } else if (response.type === 'GRID_REFRESH') {
          this.refreshAssignedGrid();
        } else if (response.type === 'GRID_VALUE_CHANGE') {
          this.onAssignedSupplyValueChange(response.data);
        } else if (response.type === 'GRID_SELECTION_CHANGE_ATTEMPT') {
          this.onAssignedSupplySelectionChange(response.data);
        } else if (response.type === 'GRID_SELECTION_CHANGE') {
          this.updateAssignedEntities();
        } else if (response.type === 'CONFIRM_LIMIT_ASSIGN') {
          this.changeAssignOverride(false);
        } else if (response.type === 'MODAL_HIDE') {
          if (response.data.component === 'confirm-limit-assign' && response.data.source === 'cancel') {
            this.assignOverrideSettings.state = true;
          }
        } else if (response.type === 'CONFIGURATION_LOADED') {
          if (response.data && response.data.forcedChange) {
            this.initializeDemandData(false);
          } else {
            this.router.navigate(['/demand/manage']).then(() => {
              return;
            });
          }
        }
      })
    );
    this.isCampaignFeatureEnabled = this.userService.getFeatureState('manage_campaigns');
    this.demandUrlValid = true;
    this.customMVRCappingLimit = 0;
    this.prebidServerParams = {
      bidders: [{ bidder: 'smartAdServer', params: [{ name: 'networkId', type: 'number' }], id: 35 }],
    };
    this.oemPrebidBiddersAllowed = ['pubmatic', 'unruly', 'grid'];
    this.placements = {
      plcmt: [
        { label: 'Instream', value: 1 },
        { label: 'Accompanying Content', value: 2 },
        { label: 'Interstitial', value: 3 },
        { label: 'No Content/Standalone', value: 4 },
      ],
      placement: [
        { label: 'In-Stream', value: 1 },
        { label: 'In-Banner', value: 2 },
        { label: 'In-Article', value: 3 },
        { label: 'In-Feed', value: 4 },
        { label: 'Interstitial-Slider-Floating', value: 5 },
      ],
    };
    this.schainDropDownValue = '';
    this.schainDropDown = [
      { label: 'do not send schain', value: 'dntssch' },
      { label: 'Schain override', value: 'scho' },
      { label: 'Schain addition', value: 'scha' },
      { label: 'Keep hard coded', value: 'keepHardCodedSchain' },
    ];
    this.schainsForDropdown = [];
    this.selectedPlacement = {} as any;
  }

  ngOnDestroy() {
    this.clearDemandPartnersRefresh();
  }

  ngOnInit() {
    this.subscriptions.push(
      this.route.params.subscribe((params: any) => {
        if (params.id && params.id !== 'new') {
          this.routeParams.id = params.id;
          this.editMode = true;
        }
        if (this.editMode) {
          this.initializeDemandData();
        } else {
          this.parseDemandData();
        }
      })
    );
    this.subscriptions.push(
      this.route.data.subscribe((data: any) => {
        this.duplicateMode = data.duplicateMode;
        this.setPageTitle();
      })
    );
  }

  setPageTitle(): void {
    this.duplicateMode
      ? this.sharedService.setPageTitle('DUPLICATE_DEMAND', this.demandData.vast_name)
      : this.editMode
        ? this.sharedService.setPageTitle('EDIT_DEMAND', this.demandData.vast_name)
        : this.sharedService.setPageTitle('NEW_DEMAND');
  }

  initializeDemandData(changeNetworkAllowed: boolean = true) {
    this.isLoading = true;
    this.assignedSupplyData = [];
    this.assignedSupplyDataDisplayed = [];
    this.assignedCampaignDataDisplayed = [];
    this.getDemand().subscribe(
      (response: any) => {
        if (response.status.toLowerCase() === 'failed') {
          this.onError(true);
        } else {
          if (response.networkData && response.networkData.networkChanged && changeNetworkAllowed) {
            this.userService.changeNetworkIfNeeded(response);
          } else {
            const demandType: any = _.find(this.demandService.demandTypes, { id: +response.vast.vast_type });
            this.getDemandResponse = response.vast;
            this.demandTypeName = demandType ? demandType.name : '';
            this.parseDemandData();
          }
        }
      },
      () => {
        this.onError(false);
      }
    );
  }

  initializeEntities(onlySupplies: boolean = false) {
    this.resetTypes();
    this.resetPartners();

    // Set the loading variable to true
    this.isLoadingEntities = true;
    this.isLoadingDomainLists = true;
    this.isLoadingIPLists = true;
    this.isLoadingURLsLists = true;

    this.getSupplies().subscribe(
      (response: any) => {
        const allSupplies: Array<any> = _.cloneDeep(response);
        let itemInAssignedSupply: any;
        allSupplies.forEach((supply: any) => {
          itemInAssignedSupply = this.indexedAssignedEntities[+supply.playerId];
          supply.$$selected = itemInAssignedSupply !== undefined;
          supply.type = +supply.type;
          supply.environment = {
            is_desktop: supply.is_desktop === '1',
            is_mobile_web: supply.is_mobile_web === '1',
            is_mobile_app: supply.is_mobile_app === '1',
            is_ctv: supply.is_ctv === '1',
          };
          supply.limit_assign = supply.limit_assign === '1';

          if (this.userService.getFeatureState('hb_type') || this.userService.isCedatoPublisherNetwork()) {
            supply.hb = supply.hb === '1';
          }

          if (!this.sharedService.isEmpty(supply.parentNetworkName)) {
            supply.partner = supply.parentNetworkName;
          }
          supply.fixed_cost = '';
          supply.revshare_cost = '';
          if (this.demandService.isRevshareCPM(+supply.cost_type)) {
            supply.revshare_cost = parseFloat(supply.cost_value);
          } else if (this.demandService.isFixedCPM(+supply.cost_type)) {
            supply.fixed_cost = parseFloat(supply.cost_value);
          }
          supply.$$link = '/supply/manage/' + supply.playerId;
        });
        this.assignedSupplyData = allSupplies;
        if (this.editMode && !onlySupplies) {
          this.updateAssignedEntities();
        }
        this.refreshAssignedGrid();

        this.isLoadingEntities = false;

        forkJoin(this.getDomainLists(), this.getIPLists(), this.getURLsLists()).subscribe(
          ([resDomains, resIP, resURLs]) => {
            this.domainLists = resDomains && _.isArray(resDomains) && resDomains.length ? resDomains : [];
            this.ipLists = resIP && _.isArray(resIP) && resIP.length ? resIP : [];
            this.URLsList = resURLs && _.isArray(resURLs) && resURLs.length ? resURLs : [];

            this.isLoadingIPLists = false;
            this.isLoadingDomainLists = false;
            this.isLoadingURLsLists = false;
          }
        );
      },
      () => {
        this.onError();
      }
    );
  }

  resetTypes() {
    let allowType: boolean;
    this.demandTypes = [];

    for (let i = 0; i < this.demandService.demandTypes.length; i++) {
      allowType = this.demandService.demandTypes[i].featureFlag
        ? this.userService.getFeatureState(this.demandService.demandTypes[i].featureFlag)
        : true;
      // special case for CedatoX Demands:
      // they should be supported in all reports,
      // but can be created ONLY via Marketplace network
      if (this.demandService.demandTypes[i].id === 1 && !this.userService.getFeatureState('cedatox_marketplace')) {
        allowType = false;
      }

      if (allowType && this.demandService.demandTypes[i].active) {
        this.demandTypes.push(this.demandService.demandTypes[i]);
      }
    }
  }

  resetPartners() {
    this.partners = [];
    for (let i = 0; i < this.sharedService.demandPartners.length; i++) {
      this.partners.push({
        label: this.sharedService.demandPartners[i].name,
        value: +this.sharedService.demandPartners[i].partnerId,
      });
    }
    this.buildSchainsForDropdown();
  }

  buildSchainsForDropdown() {
    this.schainsForDropdown = [];
    if (this.sharedService.targetingLookups && this.sharedService.targetingLookups.schains) {
      for (let i = 0; i < this.sharedService.targetingLookups.schains.length; i++) {
        const schain = this.sharedService.targetingLookups.schains[i];
        this.schainsForDropdown.push({
          label: schain.name || schain.label || 'Schain ' + schain.id,
          value: schain.id,
          id: schain.id,
        });
      }
    }
  }

  // resetDemandOwners() {
  //   this.demandOwner = [];
  //   const datasourceDemandOwner = [
  //     { codeOwner: 'programmaticDemand', ownerDesc: 'Programmatic Demand' },
  //     { codeOwner: 'directDemand', ownerDesc: 'Direct Demand' }
  //   ];
  //   for (let i = 0; i < datasourceDemandOwner.length; i++) {
  //     this.demandOwner.push({
  //       label: datasourceDemandOwner[i].ownerDesc,
  //       value: +datasourceDemandOwner[i].codeOwner,
  //     });
  //   }
  // }

  onError(demandNotFound: boolean = false) {
    const message: string = demandNotFound ? 'DEMAND_NOT_FOUND' : 'AN_ERROR_HAS_OCCURRED';
    this.originalData = _.cloneDeep(this.demandData);
    this.sharedService.showFlashMessage(this.dictionaryService.get(message), 'error');
    this.router.navigate(['/demand/manage']).then(() => {
      return;
    });
  }

  parseDemandData() {
    if (this.editMode) {
      this.demandData = this.parseDemandResponse();
      if (!this.duplicateMode) {
      } else {
        this.demandData.vast_name = this.dictionaryService.get('COPY_OF') + this.demandData.vast_name;
        delete this.demandData.playerId;
      }
    } else {
      this.demandData = _.cloneDeep(this.demandService.demandModel);

      this.demandData = _.merge(this.demandData, this.demandService.buildExtraParamsDefs());
      this.demandData.extra_params = stringify(JSON.parse(this.demandData.extra_params), {
        space: this.sharedService.formatJSONstring,
      });

      this.fetchBiddersFromJSON().then();
      this.initializeNewDemandData(this.demandData);
      // this.demandData.rtb_vendor = this.sharedService.rtbVendors[0].id;
    }
    this.visibleSections = this.buildSideMenuIcons();
    this.setPageTitle();
    this.onInitializationComplete();
  }

  initializeNewDemandData(demandData: any) {
    // feature flag modifications
    demandData.targeting.ivt_ispass = this.userService.getFeatureState('ivt_ispass') ? 1 : 0;
    demandData.targeting.viewability_ispass = this.userService.getFeatureState('viewability_ispass') ? 1 : 0;
  }

  initializeCampaigns(): Promise<void> {
    return new Promise((resolve) => {
      let currency = '';
      this.isLoadingCampaigns = true;
      this.getCampaigns().subscribe(
        (response: any) => {
          if (response.status.toLowerCase() === 'ok' && _.isArray(response.data)) {
            const data: Array<any> = [];
            for (let i = 0; i < response.data.length; i++) {
              currency = this.campaignsService.getCurrencyString(+response.data[i].b_c);
              data[i] = {};
              data[i].$$id = +response.data[i].b_i;
              data[i].$$active = !!+response.data[i].b_a;
              data[i].b_active = response.data[i].b_a;
              data[i].b_id = response.data[i].b_i;
              data[i].b_name = response.data[i].b_n;
              data[i].b_start = response.data[i].b_s;
              data[i].b_end = response.data[i].b_e;
              data[i].b_running = this.campaignsService.getRunningState(response.data[i]);
              data[i].b_hourly =
                +response.data[i].b_i === 0
                  ? '–'
                  : currency +
                    this.sharedService.toLocaleString(this.campaignsService.parseFloat(response.data[i].b_h));
              data[i].b_daily =
                +response.data[i].b_d === 0
                  ? '–'
                  : currency +
                    this.sharedService.toLocaleString(this.campaignsService.parseFloat(response.data[i].b_d));

              data[i].$$link = `/campaigns/manage/${response.data[i].b_i}`;
            }
            this.assignedCampaignDataDisplayed = data;

            if (!data.length) {
              const campaignsSection: any = _.find(this.allSections, { name: 'ASSIGNED_CAMPAIGNS' });
              campaignsSection.toggleStatus = false;
            }
          } else {
            this.onError(true);
          }
        },
        () => {
          this.onError(false);
        }
      );

      this.isLoadingCampaigns = false;
      resolve();
    });
  }

  onInitializationComplete(): void {
    switch (this.demandData.type) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
        if (this.editMode) {
          this.assignedEntities = _.cloneDeep(this.getDemandResponse.vast_players);
          this.updateIndexedAssignedEntities();
        }

        if (this.editMode && this.isCampaignFeatureEnabled) {
          this.initializeCampaigns().then(() => {
            this.initializeEntities();
            this.isLoading = false;
          });
        } else {
          this.initializeEntities();
          this.isLoading = false;
        }

        setTimeout(() => {
          this.originalData = _.cloneDeep(this.demandData);
        });
        break;
      default:
        this.onError();
    }

    this.getCustomMVRMaxValue(+this.demandData.type);
  }

  getDemand() {
    return this.httpService.post('vdsp_ws/getVast', { vast_id: this.routeParams.id, onlyActive: true });
  }

  getCampaigns() {
    return this.httpService.post('budget_manager/getBudgetsByEntity', { id: this.routeParams.id, type: 3 });
  }

  getSupplies() {
    const params: any = {};
    if (this.assignedSupplyFilters.active.length > 0) {
      params.activeDemands = this.assignedSupplyFilters.active[0] ? 1 : 0;
    }
    if (this.userService.getFeatureState('hb_type') || this.userService.isCedatoPublisherNetwork()) {
      params.hb_type = 1;
    }

    return this.httpService.post('vdsp_ws/getSupplies', params);
  }

  getDomainLists() {
    return this.httpService.post('restriction_lists/getDomainListsUI');
  }

  getIPLists() {
    return this.httpService.post('restriction_lists/getIPListsUI');
  }

  getURLsLists() {
    return this.httpService.post('restriction_lists/getURLsListsUI');
  }

  onDayTargetingFromHourChange($event, currentDaySetting, changeToHour: boolean = false) {
    // modify here to hour dropdown list
    if ($event) {
      const currentTargetingDayFromHour = $event;
      currentDaySetting.toHour.Options = [];
      const fromHourIndex = this.originalTargetingDayFromHourList.indexOf(currentTargetingDayFromHour);
      for (let toHourIndex = fromHourIndex; toHourIndex < this.originalTargetingDayToHourList.length; toHourIndex++) {
        currentDaySetting.toHour.Options.push(this.originalTargetingDayToHourList[toHourIndex]);
      }
      if (changeToHour && currentDaySetting.toHour.Value == null) {
        currentDaySetting.toHour.Value = currentDaySetting.toHour.Options[0];
      }
    }
  }

  markNonValidMacros() {
    let urlMacrosValid = true;
    this.demandData.vast_url = this.demandData.vast_url.replace(/ /g, '%20');
    let formattedText = this.demandData.vast_url;
    const macrosList = this.demandService.getMacroList();
    const thisArea = document.getElementById('vastURL');
    const regex = /[?&]+([^=&]+)=([^&]*)/gi;
    const macroRegex = /\[[^\[\]]+\]/g;
    let m: RegExpExecArray;
    let m_sub: RegExpExecArray;
    while ((m = regex.exec(this.demandData.vast_url)) !== null) {
      while ((m_sub = macroRegex.exec(m[2])) !== null) {
        const foundMacro = macrosList.includes(m_sub[0]);
        if (!foundMacro) {
          formattedText = formattedText.replace(m_sub[0], `<mark><span>${m_sub[0]}</span></mark>`);
          urlMacrosValid = false;
        }
      }
    }

    // Resize Textarea by content
    if (formattedText.length !== 0) {
      thisArea.blur();
      thisArea.focus();
    }
    thisArea.setAttribute('style', 'height: 1px; min-height: 1px;');
    thisArea.setAttribute(
      'style',
      `height: ${thisArea.scrollHeight + 2}px; min-height: ${thisArea.scrollHeight + 2}px;`
    );
    this.demandUrlValid = urlMacrosValid;
    this.demandUrlFormatted = formattedText;
  }

  onDayTargetingToHourChange($event, currentDaySetting, changeFromHour: boolean = false) {
    // modify here to hour dropdown list
    if ($event) {
      const currentTargetingDayToHour = $event;
      currentDaySetting.fromHour.Options = [];
      const toHourIndex = this.originalTargetingDayToHourList.indexOf(currentTargetingDayToHour);
      for (let fromHourIndex = 0; fromHourIndex <= toHourIndex; fromHourIndex++) {
        currentDaySetting.fromHour.Options.push(this.originalTargetingDayFromHourList[fromHourIndex]);
      }
      if (changeFromHour && currentDaySetting.fromHour.Value == null) {
        currentDaySetting.fromHour.Value = currentDaySetting.fromHour.Options[0];
      }
    }
  }

  removeDayTargeting(dayTargetingIndex: number) {
    this.demandData.targeting.time_targeting.list.splice(dayTargetingIndex, 1);
  }

  addDayTargeting() {
    const newDayTargeting = _.cloneDeep({
      day: null,
      fromHour: { Value: null, Options: [] },
      toHour: { Value: null, Options: [] },
    });
    newDayTargeting.fromHour.Options = _.cloneDeep(this.originalTargetingDayFromHourList);
    newDayTargeting.toHour.Options = _.cloneDeep(this.originalTargetingDayToHourList);
    this.demandData.targeting.time_targeting.list.push(newDayTargeting);
  }

  updateAssignedEntities(specificItem: any = null) {
    let foundAssignedEntity: any;
    let state: boolean;
    let currItem: any;
    if (specificItem !== null) {
      foundAssignedEntity = this.indexedAssignedEntities[+specificItem.playerId];
      if (!foundAssignedEntity) {
        this.indexedAssignedEntities[+specificItem.playerId] = specificItem;
      } else {
        if (specificItem.$$selected) {
          this.indexedAssignedEntities[+foundAssignedEntity.playerId] = specificItem;
        } else {
          delete this.indexedAssignedEntities[+foundAssignedEntity.playerId];
        }
      }
    } else {
      if (this.assignedSupplyGrid) {
        if (this.assignedSupplyGrid.displayedData.length > 0) {
          const indexedAssignedSupplyData = this.sharedService.getIndexedArray(this.assignedSupplyData, 'playerId');
          this.assignedSupplyGrid.displayedData.forEach((item: any) => {
            foundAssignedEntity = this.indexedAssignedEntities[+item.playerId];
            currItem = indexedAssignedSupplyData[+item.playerId];
            state = item.$$selected;
            if (state && !foundAssignedEntity) {
              this.indexedAssignedEntities[+item.playerId] = item;
            } else if (!state && !!foundAssignedEntity) {
              delete this.indexedAssignedEntities[+item.playerId];
            }
            if (currItem) {
              currItem.$$selected = state;
            }
          });
        }
      }
    }
    this.assignedEntities = [];
    for (const playerId in this.indexedAssignedEntities) {
      const currPlayer = this.indexedAssignedEntities[+playerId];
      this.assignedEntities.push({
        playerId: currPlayer.playerId,
        active: 1,
        $$selected: currPlayer.$$selected,
      });
    }
  }

  refreshAssignedGrid() {
    this.onAssignedSupplyTabSelected(this.assignedSupplySelectedTab);
  }

  refreshAssignedGridForCPM() {
    clearTimeout(this.vastCpmTimer);
    this.vastCpmTimer = setTimeout(() => {
      this.refreshAssignedGrid();
    }, 1000);
  }

  onAssignedSupplyTabSelected(id: number) {
    const assignedSupplyData: Array<any> = _.cloneDeep(this.assignedSupplyData);
    const vast_cpm: number = this.getVastCPM();
    const isFixedCPM: Function = this.demandService.isFixedCPM;
    const isRevshareCPM: Function = this.demandService.isRevshareCPM;
    const isNoneCPM: Function = this.demandService.isNoneCPM;
    const revshareDX: boolean = this.demandData.type === 1 && this.demandData.costType === 4;
    let eligible: Array<any>;
    let ineligible: Array<any>;

    if (+this.demandData.type === 1 && !this.userService.isAllowedCx2Cx()) {
      _.remove(assignedSupplyData, (supply: any) => {
        return +supply.type === 2;
      });
    }

    // if this is a revshare demandX don't populate ineligible arrays
    if (revshareDX) {
      this.assignedSupplyDataDisplayed = _.cloneDeep(assignedSupplyData);
      // "Bad" cells (low CPM warning)
      this.assignedSupplyDataDisplayed.forEach((supply: any) => {
        supply.$$badSelection =
          supply.$$selected && isFixedCPM(+supply.cost_type) && parseFloat(supply.cost_value) >= vast_cpm;
      });
      this.assignedSupplyTabsData = [
        {
          title: this.dictionaryService.get('VIEW_ALL') + ' (' + assignedSupplyData.length + ')',
        },
      ];
      // Display the relevant data
      this.assignedSupplySelectedTab = 0;
    } else {
      // Filter the eligible/ineligible data by cost-value
      eligible = _.filter(assignedSupplyData, function (supply: any) {
        return vast_cpm > 0
          ? (isFixedCPM(+supply.cost_type) && parseFloat(supply.cost_value) < vast_cpm) ||
              isRevshareCPM(supply.cost_type) ||
              isNoneCPM(supply.cost_type)
          : true;
      });
      ineligible = _.filter(assignedSupplyData, function (supply: any) {
        return vast_cpm > 0 ? isFixedCPM(+supply.cost_type) && parseFloat(supply.cost_value) >= vast_cpm : false;
      });
      // Display the relevant data
      switch (id) {
        case 0:
          this.assignedSupplyDataDisplayed = _.cloneDeep(assignedSupplyData);
          break;
        case 1:
          this.assignedSupplyDataDisplayed = _.cloneDeep(eligible);
          break;
        case 2:
          this.assignedSupplyDataDisplayed = _.cloneDeep(ineligible);
          break;
      }
      // "Bad" cells (low CPM warning)
      this.assignedSupplyDataDisplayed.forEach((supply: any) => {
        supply.$$badSelection =
          vast_cpm > 0 &&
          supply.$$selected &&
          isFixedCPM(+supply.cost_type) &&
          parseFloat(supply.cost_value) >= vast_cpm;
      });
      this.assignedSupplyTabsData = [
        { title: this.dictionaryService.get('VIEW_ALL') + ' (' + assignedSupplyData.length + ')' },
        { title: this.dictionaryService.get('VIEW_ELIGIBLE') + ' (' + eligible.length + ')' },
        {
          title:
            this.dictionaryService.get('VIEW_INELIGIBLE') + ' <span class="badText">(' + ineligible.length + ')</span>',
        },
      ];
      // Display the relevant data
      this.assignedSupplySelectedTab = id;
    }
  }

  onAssignedSupplyValueChange($event: any) {
    const dataItem: any = _.cloneDeep($event.dataItem);
    this.assignedSupplyData[_.findIndex(this.assignedSupplyData, { playerId: dataItem.playerId })] = dataItem;
    this.updateAssignedEntities(dataItem);
  }

  onAssignedSupplySelectionChange(allSelectedState: boolean) {
    const title: string = allSelectedState ? 'SELECT_ALL' : 'UNSELECT_ALL';
    this.modalsService.showModal({
      title: this.dictionaryService.get(title),
      component: 'confirm-assign',
      data: {
        state: allSelectedState,
        type: 'supply',
      },
    });
  }

  onAssignedSupplyFilterChange($event: any) {
    this.assignedSupplyFilters = $event;
    if ($event.active !== this.assignedSupplyFilters.active) {
      this.initializeEntities(true);
    }
  }

  onAssignOverrideChange($event: any) {
    let amount: number;
    if ($event) {
      this.changeAssignOverride($event);
    } else {
      amount = _.filter(this.assignedSupplyData, (playerId: any) => {
        if (playerId.limit_assign === '1') {
          return _.find(this.assignedEntities, { playerId: playerId.playerId });
        }
      }).length;
      if (amount > 0) {
        this.modalsService.showModal({
          title: this.dictionaryService.get('ALLOW_TO_ASSIGN_LIMITED_ASSIGNMENT_SUPPLY'),
          component: 'confirm-limit-assign',
          data: {
            amount: amount,
            type: 'demand',
          },
        });
      } else {
        this.changeAssignOverride($event);
      }
    }
  }

  changeAssignOverride(state: boolean) {
    this.assignOverrideSettings.state = state;
    if (!state) {
      this.assignedEntities.forEach((assigned: any) => {
        const supply: any = _.find(this.assignedSupplyData, { playerId: assigned.playerId });
        if (supply.limit_assign === '1') {
          supply.$$selected = false;
          this.updateAssignedEntities(supply);
        }
      });
    }
    this.refreshAssignedGrid();
  }

  parseDemandResponse() {
    const demandResponse: any = {};
    const targeting = this.getDemandResponse.targeting ? this.getDemandResponse.targeting[0] : {};
    let currTargetingItem: any;
    let currTargetingLimits: any;
    let currCappingItem: any;
    let capType: number;
    const callbacks: Array<any> = [];
    let currEvent: any;
    let currCallback: any;
    let bidderAdapterIndex: number;
    const extraParamsSectionItem: any = _.find(this.allSections, { value: 'extraParams' });
    // Settings
    demandResponse.vastId = this.sharedService.parseNumeric(this.getDemandResponse.vastId);
    demandResponse.vast_name = this.getDemandResponse.vast_name;
    demandResponse.type = this.sharedService.parseNumeric(this.getDemandResponse.vast_type);
    demandResponse.is_desktop = this.getDemandResponse.is_desktop === '1';
    demandResponse.is_mobile_app = this.getDemandResponse.is_mobile_app === '1';
    demandResponse.is_mobile_web = this.getDemandResponse.is_mobile_web === '1';
    demandResponse.is_ctv = this.getDemandResponse.is_ctv === '1';
    demandResponse.partnerId = this.sharedService.parseNumeric(this.getDemandResponse.partnerId);
    demandResponse.partnerName = this.getDemandResponse.partnerName;
    demandResponse.networkId = this.userService.networkData.networkId;
    if (!this.sharedService.isEmpty(this.getDemandResponse.parentNetworkName)) {
      demandResponse.partnerName = this.getDemandResponse.parentNetworkName;
    }
    demandResponse.isMobile = demandResponse.is_mobile_web || demandResponse.is_mobile_app;
    demandResponse.vast_url = this.getDemandResponse.vast_url;
    demandResponse.user_type = this.sharedService.parseNumeric(this.getDemandResponse.user_type);
    demandResponse.vast_cpm = this.sharedService.parseNumeric(this.getDemandResponse.vast_cpm);
    demandResponse.is_active = this.getDemandResponse.is_active === '1';
    demandResponse.preroll = this.getDemandResponse.preroll === '1';
    if (this.userService.getFeatureState('demand_first_ad_slot')) {
      demandResponse.first_ad_slot = this.getDemandResponse.first_ad_slot === '1';
    }
    demandResponse.limitAssign = this.getDemandResponse.limit_assign === '1';
    demandResponse.is_intent_demand = this.getDemandResponse.is_intent_demand === '1';
    demandResponse.is_google_demand = this.getDemandResponse.is_google_demand === '1';
    demandResponse.premium = this.getDemandResponse.premium === '1';
    demandResponse.allow_s2s = this.getDemandResponse.allow_s2s === '1';
    demandResponse.rtb_vendor = this.sharedService.parseNumeric(this.getDemandResponse.rtb_vendor);
    demandResponse.deal_id = DemandService.getRTBDemandDealID(this.getDemandResponse.deal_id);
    demandResponse.floorCPM = this.sharedService.parseNumeric(this.getDemandResponse.floorCPM);

    this.getDynamicDemandValue(this.getDemandResponse.extra_params);
    this.getPushPercentageValue(this.getDemandResponse.extra_params);
    this.getMaxDurationValue(this.getDemandResponse.extra_params);
    this.getDemandSubType(this.getDemandResponse.extra_params);
    this.getDemandGoogleSlotId(this.getDemandResponse.extra_params);
    this.getDemandGoogleSlotDimensions(this.getDemandResponse.extra_params);
    this.getDemandDisplayFallback(this.getDemandResponse.extra_params);
    this.getGoogleKeyValueEnabled(this.getDemandResponse.extra_params);
    this.getGoogleKeyValueParam(this.getDemandResponse.extra_params);

    demandResponse.extra_params_enabled = this.sharedService.parseBoolean(this.getDemandResponse.extra_params_enabled);
    demandResponse.extra_params = demandResponse.extra_params_enabled
      ? stringify(JSON.parse(this.getDemandResponse.extra_params), { space: this.sharedService.formatJSONstring })
      : stringify(JSON.parse(this.demandService.extraParamsDefaultValue.json), {
          space: this.sharedService.formatJSONstring,
        });
    this.getExperimentalFeatures(demandResponse.extra_params);
    this.isMaxImpActive = !!this.experimentalFeatures.maxImp;
    this.isMaxReqActive = !!this.experimentalFeatures.maxReq;
    this.isPlayCapInSlotActive = !!this.experimentalFeatures.playCapInSlot;
    this.isGapInSlotActive = !!this.experimentalFeatures.gapInSlot;

    if (extraParamsSectionItem) {
      extraParamsSectionItem.onIf =
        demandResponse.extra_params_enabled &&
        stringify(JSON.parse(demandResponse.extra_params)) !==
          stringify(JSON.parse(this.demandService.extraParamsDefaultValue.json));
    }

    if (this.getDemandResponse.vast_type == 4) {
      if (this.demandService.bidders && this.demandService.bidders.length) {
        this.fetchBiddersFromJSON().then(() => {
          this.bidderDataError = false;
          demandResponse.bidder = this.getDemandResponse.bidder;
          if (this.getDemandResponse.bidder) {
            const currentBidderConf = _.find(this.demandService.bidders, {
              value: +this.getDemandResponse.bidder.bidderId,
            });
            if (currentBidderConf && !_.find(this.demandService.biddersAllowed, { value: currentBidderConf.value })) {
              this.bidderDisabledPartner = currentBidderConf.label;
            } else {
              this.bidderDisabledPartner = null;
            }
            this.demandData.bidder.conf = {};
            this.demandData.bidder.conf.adapters = [];
            _.map(this.demandService.bidderConfs, (val, key) => {
              if (val.bidder === currentBidderConf.alias) {
                delete val.bidder;
                val.label = key;
                val.value = key;
                demandResponse.bidder.conf.adapters.push(val);
              }
            });

            if (+currentBidderConf.value === APPNEXUS_PREBID_BIDDER_ID) {
              this.patchAppNexusAdaptersForPbserver(demandResponse.bidder.conf.adapters);
              demandResponse.bidder.json = this.migrateAppNexusBidderJson(demandResponse.bidder.json || '{}');
            }

            bidderAdapterIndex = this.demandService.chooseAdapter(
              demandResponse.bidder.conf,
              demandResponse.bidder.json
            );
            demandResponse.bidder.conf.currentAdapter = _.cloneDeep(
              demandResponse.bidder.conf.adapters[bidderAdapterIndex]
            );
          }
        });
      } else {
        this.bidderDataError = true;
      }
    }
    // Settings - CedatoX Demand
    demandResponse.subPlayerId = this.sharedService.parseNumeric(this.getDemandResponse.subPlayerId);
    demandResponse.parentNetworkId = this.sharedService.parseNumeric(this.getDemandResponse.parentNetworkId);
    demandResponse.parentNetworkName = this.getDemandResponse.parentNetworkName;
    demandResponse.cxTrafficSourceAllowedHTML = this.getDemandResponse.cx_traffic_source_allowed_html === '1';
    demandResponse.cxTrafficSourceAllowedVAST = this.getDemandResponse.cx_traffic_source_allowed_vast === '1';
    demandResponse.costType = this.sharedService.parseNumeric(this.getDemandResponse.cost_type);
    demandResponse.costValue = this.sharedService.parseNumeric(this.getDemandResponse.cost_value);
    demandResponse.assigned_via_cedatox = this.sharedService.parseNumeric(this.getDemandResponse.assigned_via_cedatox);
    // Targeting
    demandResponse.targeting = _.cloneDeep(this.demandService.demandModel.targeting);

    if (targeting) {
      demandResponse.targeting.targeting_id = +targeting.targeting_id;
      demandResponse.targeting.app_bundle_oper = +targeting.app_bundle_oper;
      demandResponse.targeting.detected_domain_oper = +targeting.detected_domain_oper;
      demandResponse.targeting.location.type = +targeting.country_codes_oper;
      demandResponse.targeting.iasAvoidance = {};
      demandResponse.targeting.iasTargeting = {};
      demandResponse.targeting.highRiskAvoidance = {};
      demandResponse.targeting.browsers.type = +targeting.browsers_oper;
      demandResponse.targeting.os.type = +targeting.os_oper;
      demandResponse.targeting.targetingSizes.type = +targeting.sizes_oper;
      demandResponse.targeting.viewability = +targeting.viewability;
      demandResponse.targeting.viewability_ispass = +targeting.viewability_ispass;
      demandResponse.targeting.viewability_enabled = targeting.viewability_enabled === '1';
      demandResponse.targeting.ivt = +targeting.ivt;
      demandResponse.targeting.ivt_ispass = +targeting.ivt_ispass;
      demandResponse.targeting.ivt_enabled = targeting.ivt_enabled === '1';
      demandResponse.targeting.envs.type = +targeting.envs_oper;
      demandResponse.targeting.vast_domains.type = +targeting.vast_domains_oper;
      demandResponse.targeting.dma.type = +targeting.dma_oper;
      demandResponse.targeting.state.type = +targeting.state_oper;
      demandResponse.targeting.schains = null;
      if (targeting.schain_id && !this.sharedService.isEmpty(targeting.schain_id)) {
        const currTargetingItem: any = _.find(this.sharedService.targetingLookups.schains, {
          id: targeting.schain_id,
        });
        if (currTargetingItem) {
          demandResponse.targeting.schains = currTargetingItem;
        }
      }
      if (!demandResponse.targeting.viewability_enabled) {
        demandResponse.targeting.viewability = this.demandService.demandModel.targeting.viewability;
        demandResponse.targeting.viewability_ispass = this.demandService.demandModel.targeting.viewability_ispass;
      }
      if (!demandResponse.targeting.ivt_enabled) {
        demandResponse.targeting.ivt = this.demandService.demandModel.targeting.ivt;
        demandResponse.targeting.ivt_ispass = this.demandService.demandModel.targeting.ivt_ispass;
      }
      targeting.country_codes =
        typeof targeting.country_codes === 'string' ? targeting.country_codes.split(',') : targeting.country_codes;
      targeting.ias_segments_exclusion =
        typeof targeting.ias_segments_exclusion === 'string'
          ? targeting.ias_segments_exclusion.split(',')
          : targeting.ias_segments_exclusion;
      targeting.ias_segments_inclusion =
        typeof targeting.ias_segments_inclusion === 'string'
          ? targeting.ias_segments_inclusion.split(',')
          : targeting.ias_segments_inclusion;
      targeting.browsers = typeof targeting.browsers === 'string' ? targeting.browsers.split(',') : targeting.browsers;
      targeting.os = typeof targeting.os === 'string' ? targeting.os.split(',') : targeting.os;
      targeting.sizes = typeof targeting.sizes === 'string' ? targeting.sizes.split(',') : targeting.sizes;
      targeting.sizes_ui = typeof targeting.sizes_ui === 'string' ? targeting.sizes_ui.split('|') : targeting.sizes_ui;
      targeting.envs = typeof targeting.envs === 'string' ? targeting.envs.split(',') : targeting.envs;
      targeting.vast_domains =
        typeof targeting.vast_domains === 'string' ? targeting.vast_domains.split(',') : targeting.vast_domains;
      targeting.dma = typeof targeting.dma === 'string' ? targeting.dma.split(',') : targeting.dma;
      targeting.state = typeof targeting.state === 'string' ? targeting.state.split(',') : targeting.state;
      targeting.time_targeting =
        typeof targeting.time_targeting === 'string' && targeting.time_targeting
          ? targeting.time_targeting.split(',')
          : [];
      for (let i = 0; i < targeting.country_codes.length; i++) {
        currTargetingItem = _.find(this.sharedService.targetingLookups.countries, function (o) {
          return o.iso === targeting.country_codes[i];
        });
        if (currTargetingItem) {
          demandResponse.targeting.location.list.push(currTargetingItem);
        }
      }

      // IAS
      if (!demandResponse.targeting.iasAvoidance.list) {
        demandResponse.targeting.iasAvoidance.list = [];
        demandResponse.targeting.iasAvoidance.enabled = false;
      }

      if (!demandResponse.targeting.iasTargeting.list) {
        demandResponse.targeting.iasTargeting.list = [];
        demandResponse.targeting.iasTargeting.enabled = false;
      }

      if (!demandResponse.targeting.highRiskAvoidance.list) {
        demandResponse.targeting.highRiskAvoidance.list = [];
        demandResponse.targeting.highRiskAvoidance.enabled = false;
      }

      // Load IAS Exclusion elements from Server
      if (Array.isArray(targeting.ias_segments_exclusion) && targeting.ias_segments_exclusion.length > 0) {
        for (let index = 0; index < targeting.ias_segments_exclusion.length; index++) {
          // regualr exclusions
          currTargetingItem = _.find(this.iasExcList, function (iasExcludeObj) {
            return iasExcludeObj.id === targeting.ias_segments_exclusion[index];
          });
          // try regualr ias avoidance
          if (currTargetingItem) {
            demandResponse.targeting.iasAvoidance.list.push(currTargetingItem);
          } else {
            // try high risk
            currTargetingItem = _.find(this.iasHighRisk, function (highRiskObj) {
              return highRiskObj.id === targeting.ias_segments_exclusion[index];
            });
            if (currTargetingItem) {
              demandResponse.targeting.highRiskAvoidance.list.push(currTargetingItem);
            }
          }
        }
      }

      demandResponse.targeting.iasAvoidance.enabled =
        demandResponse.targeting.iasAvoidance.list.length > 0 ||
        demandResponse.targeting.highRiskAvoidance.list.length > 0;

      // Load IAS Inclusion elements from Server
      if (Array.isArray(targeting.ias_segments_inclusion) && targeting.ias_segments_inclusion.length > 0) {
        for (let index = 0; index < targeting.ias_segments_inclusion.length; index++) {
          currTargetingItem = _.find(this.iasIncList, function (iasIncludeObj) {
            return iasIncludeObj.id === targeting.ias_segments_inclusion[index];
          });
          if (currTargetingItem) {
            demandResponse.targeting.iasTargeting.list.push(currTargetingItem);
          }
        }
      }
      demandResponse.targeting.iasTargeting.enabled = demandResponse.targeting.iasTargeting.list.length > 0;

      for (let i = 0; i < targeting.browsers.length; i++) {
        currTargetingItem = _.find(this.sharedService.targetingLookups.browsers, function (o) {
          return o.code === targeting.browsers[i].split(':')[0];
        });
        if (currTargetingItem) {
          currTargetingLimits = targeting.browsers[i].split(':')[1].split('-');
          currTargetingItem.from =
            currTargetingLimits[0] !== 'latest' ? currTargetingLimits[0] : this.dictionaryService.get('LATEST');
          currTargetingItem.to =
            currTargetingLimits[1] !== 'latest' ? currTargetingLimits[1] : this.dictionaryService.get('LATEST');
          demandResponse.targeting.browsers.list.push(currTargetingItem);
        }
      }
      for (let i = 0; i < targeting.os.length; i++) {
        currTargetingItem = _.find(this.sharedService.targetingLookups.os, function (o) {
          return o.code === targeting.os[i].split(':')[0];
        });
        if (currTargetingItem) {
          currTargetingLimits = targeting.os[i].split(':')[1].split('-');
          currTargetingItem.from =
            currTargetingLimits[0] !== 'latest' ? currTargetingLimits[0] : this.dictionaryService.get('LATEST');
          currTargetingItem.to =
            currTargetingLimits[1] !== 'latest' ? currTargetingLimits[1] : this.dictionaryService.get('LATEST');
          demandResponse.targeting.os.list.push(currTargetingItem);
        }
      }
      for (let i = 0; i < targeting.sizes.length; i++) {
        currTargetingItem = _.find(this.sharedService.targetingLookups.targetingSizes, function (o) {
          return o.targeting_playerSize_id === targeting.sizes[i];
        });
        if (currTargetingItem) {
          demandResponse.targeting.targetingSizes.list.push(currTargetingItem);
        }
      }
      for (let i = 0; i < targeting.sizes_ui.length; i++) {
        if (!this.sharedService.isEmpty(targeting.sizes_ui[i])) {
          targeting.sizes_ui[i] = JSON.parse(targeting.sizes_ui[i]);
          demandResponse.targeting.targetingSizes.list.push({
            name: targeting.sizes_ui[i].n,
            custom: true,
            operator: targeting.sizes_ui[i].o,
            width: +targeting.sizes_ui[i].w,
            height: +targeting.sizes_ui[i].h,
          });
        }
      }
      for (let i = 0; i < targeting.envs.length; i++) {
        demandResponse.targeting.envs.list.push(targeting.envs[i]);
      }
      for (let i = 0; i < targeting.vast_domains.length; i++) {
        if (!this.sharedService.isEmpty(targeting.vast_domains[i])) {
          demandResponse.targeting.vast_domains.list.push(targeting.vast_domains[i]);
        }
      }
      if (targeting.dma && targeting.dma.length) {
        for (let i = 0; i < targeting.dma.length; i++) {
          if (!this.sharedService.isEmpty(targeting.dma[i])) {
            const currTargetingItem: any = _.find(this.sharedService.targetingLookups.DMAs, {
              dma_id: targeting.dma[i],
            });
            if (currTargetingItem) {
              demandResponse.targeting.dma.list.push(currTargetingItem);
            }
          }
        }
      }
      if (targeting.state && targeting.state.length) {
        for (let i = 0; i < targeting.state.length; i++) {
          if (!this.sharedService.isEmpty(targeting.state[i])) {
            const currTargetingItem: any = _.find(this.sharedService.targetingLookups.state, {
              iso: targeting.state[i],
            });
            if (currTargetingItem) {
              demandResponse.targeting.state.list.push(currTargetingItem);
            }
          }
        }
      }
      if (targeting.time_targeting && targeting.time_targeting.length) {
        // parse
        demandResponse.targeting.time_targeting.list = _.map(targeting.time_targeting, (time) => {
          const dayPart = this.parseTimeTargetingString(time);
          this.onDayTargetingFromHourChange(dayPart.fromHour.Value, dayPart);
          this.onDayTargetingToHourChange(dayPart.toHour.Value, dayPart);
          return dayPart;
        });
        // order
        demandResponse.targeting.time_targeting.list = _.orderBy(
          demandResponse.targeting.time_targeting.list,
          [
            (dayPart) => {
              return this.sharedService.targetingLookups.weekDays.indexOf(dayPart.day);
            },
            (dayPart) => {
              return this.originalTargetingDayFromHourList.indexOf(dayPart.fromHour.Value);
            },
            (dayPart) => {
              return this.originalTargetingDayToHourList.indexOf(dayPart.toHour.Value);
            },
          ],
          ['asc', 'asc', 'asc']
        );
      }

      this.targeting.location = demandResponse.targeting.location.type !== 0;
      this.targeting.browsers = demandResponse.targeting.browsers.type !== 0;
      this.targeting.os = demandResponse.targeting.os.type !== 0;
      this.targeting.targetingSizes = demandResponse.targeting.targetingSizes.type !== 0;
      this.targeting.vastDomains = demandResponse.targeting.vast_domains.type !== 0;
      this.targeting.dma = demandResponse.targeting.dma.type !== 0;
      this.targeting.timeTargeting = demandResponse.targeting.time_targeting.list.length !== 0;
      this.targeting.state = demandResponse.targeting.state.list.length !== 0;
      this.targeting.schains = demandResponse.targeting.schains !== null;
    }

    // Restrictions
    demandResponse.vast_capping = {};
    for (let i = 1; i <= this.demandService.cappingTypeSettings.length; i++) {
      capType = this.demandService.cappingTypeSettings[i - 1].id;
      currCappingItem = _.find(this.getDemandResponse.vast_capping, { cappingType: capType.toString() });

      demandResponse.vast_capping[capType] = {
        active: false,
        cappingType: capType,
        cappingValue: null,
      };
      if ([1, 2].includes(capType)) {
        demandResponse.vast_capping[capType].paceOption = 1;
      } else if ([3, 4].includes(capType)) {
        demandResponse.vast_capping[capType].intervalTypeID = 1;
        demandResponse.vast_capping[capType].capTypeID = 1;
      }

      if (currCappingItem) {
        demandResponse.vast_capping[capType].id = +currCappingItem.id;
        demandResponse.vast_capping[capType].active = true;
        demandResponse.vast_capping[capType].cappingValue = this.sharedService.toLocaleString(
          currCappingItem.cappingValue
        );
        if (currCappingItem.paceOption) {
          demandResponse.vast_capping[capType].paceOption = +currCappingItem.paceOption;
        }

        if (currCappingItem.intervalTypeID) {
          demandResponse.vast_capping[capType].intervalTypeID = +currCappingItem.intervalTypeID;
        }

        if (currCappingItem.capTypeID) {
          demandResponse.vast_capping[capType].capTypeID = +currCappingItem.capTypeID;
        }

        if ([3, 4].includes(capType)) {
          this.isFreqCappingEnabled = true;
        }
      }
    }

    demandResponse.custom_mvr = +this.getDemandResponse.custom_mvr !== 0;
    if (demandResponse.custom_mvr) {
      demandResponse.custom_user_mvr = this.sharedService.parseNumeric(this.getDemandResponse.user_mvr);
      demandResponse.user_mvr = this.isFreqCappingEnabled ? 1 : this.demandService.demandModel.user_mvr;
    } else {
      demandResponse.user_mvr = this.sharedService.parseNumeric(this.getDemandResponse.user_mvr);
      demandResponse.custom_user_mvr = this.isFreqCappingEnabled ? 1 : this.demandService.demandModel.custom_user_mvr;
    }

    demandResponse.domainListType = this.sharedService.parseNumeric(this.getDemandResponse.domain_list_type);
    demandResponse.domainLists = this.getDemandResponse.domain_lists;
    demandResponse.urlListType = this.sharedService.parseNumeric(this.getDemandResponse.url_list_type);
    demandResponse.urlLists = this.getDemandResponse.url_lists;
    demandResponse.ipListType = this.sharedService.parseNumeric(this.getDemandResponse.ip_list_type);
    demandResponse.ipLists = this.getDemandResponse.ip_lists;
    demandResponse.shouldRotate = this.getDemandResponse.should_rotate === '0';
    demandResponse.filter_ivt = this.getDemandResponse.filter_ivt;
    demandResponse.pre_bid_settings = this.getDemandResponse.pre_bid_settings;
    demandResponse.isPreBidSetGlobally =
      this.getDemandResponse.pre_bid_settings && this.getDemandResponse.pre_bid_settings.fraud;
    demandResponse.prebidFraud = demandResponse.isPreBidSetGlobally ? true : this.getDemandResponse.filter_ivt;

    // Callbacks
    this.getDemandResponse.callbacks.forEach((callback: any) => {
      currEvent = _.find(this.demandService.eventsList, (evt: any) => {
        return evt.eventId === +callback.eventId && evt.typeId === +callback.typeId;
      });
      if (currEvent) {
        currCallback = {
          callbackId: +callback.callbackId,
          url: callback.url,
          event: currEvent,
          rate: +callback.rate,
        };
        if (this.duplicateMode) {
          delete currCallback.callbackId;
        }
        callbacks.push(currCallback);
      }
    });
    demandResponse.callbacks = callbacks;
    // Override empty fields with default values
    for (const property in demandResponse) {
      if (
        demandResponse.hasOwnProperty(property) &&
        (demandResponse[property] === undefined || demandResponse[property] === null) &&
        this.demandService.demandModel.hasOwnProperty(property)
      ) {
        demandResponse[property] = this.demandService.demandModel[property];
      }
    }

    this.getExperimentalFeatures(demandResponse.extra_params);
    // Return the demand
    return demandResponse;
  }

  toggleSection(id: number) {
    this.allSections[id].toggleStatus = !this.allSections[id].toggleStatus;
  }

  onUserMvrInputTypeChanged(inputType: string) {
    switch (inputType) {
      case 'byValue':
        this.demandData.custom_mvr = true;
        break;
      case 'byScale':
        this.demandData.custom_mvr = false;
        break;
      default:
        this.demandData.custom_mvr = false;
    }
  }

  goToSection(id: number) {
    const section = document.getElementById(this.allSections[id].value);
    const yPosition = id > 0 ? section.offsetTop : 0;
    window.scroll({ top: yPosition, left: 0, behavior: 'smooth' });
    this.activeSection = id;
    if (!this.allSections[id].toggleStatus) {
      this.toggleSection(id);
    }
    setTimeout(() => {
      this.activeSection = id;
    }, 400);
  }

  getSectionsPosition() {
    return window.scrollY > 72 ? 0 : 72;
  }

  getSectionsArrowPosition() {
    return this.activeSection && document.getElementById('sectionButton' + this.activeSection)
      ? document.getElementById('sectionButton' + this.activeSection).offsetTop
      : 0;
  }

  isSectionActive(id: number) {
    let answer = false;
    const demandType = _.find(this.demandService.demandTypes, { id: this.demandData.type });
    const featureFlag: string = this.demandService.sideMenuSections[id].featureFlag;
    const isAdminOnly: boolean = this.demandService.sideMenuSections[id].isAdminOnly;
    if (demandType) {
      answer = demandType.sections[id];
    }
    if (answer && this.demandService.sideMenuSections[id].editModeOnly) {
      answer = this.editMode || this.duplicateMode;
    }
    if (
      this.demandService.sideMenuSections[id].hasOwnProperty('featureFlag') &&
      this.demandService.sideMenuSections[id].hasOwnProperty('isAdminOnly')
    ) {
      answer = answer && (this.userService.getFeatureState(featureFlag) || this.userService.isAdmin());
    } else {
      if (featureFlag) {
        answer = answer && this.userService.getFeatureState(featureFlag);
      }
      if (isAdminOnly) {
        answer = answer && this.userService.isAdmin();
      }
    }
    return answer;
  }

  buildSideMenuIcons() {
    const activeIconsSet: Array<any> = [];
    for (let i = 0; i < this.demandService.sideMenuSections.length; i++) {
      if (this.isSectionActive(i)) {
        activeIconsSet.push(this.demandService.sideMenuSections[i]);
      }
    }
    return activeIconsSet;
  }

  onDemandTypeChange($event: any) {
    this.demandData.vast_url = '';
    this.refreshAssignedGrid();

    if ($event !== 0) {
      this.demandSubType === TYPE_VIDEO;
    }

    if ($event === 3) {
      this.mvrTmpStore = {
        user_mvr: _.cloneDeep(this.demandData.user_mvr),
        custom_user_mvr: _.cloneDeep(this.demandData.custom_user_mvr),
        isChanged: true,
      };
      this.demandData.user_mvr = 1;
      this.demandData.custom_user_mvr = 1;
      this.demandData.custom_mvr = true;
    } else {
      if (this.mvrTmpStore.isChanged) {
        this.demandData.user_mvr = this.mvrTmpStore.user_mvr;
        this.demandData.custom_user_mvr = this.mvrTmpStore.custom_user_mvr;
      } else {
        this.demandData.user_mvr = _.cloneDeep(this.demandService.demandModel.user_mvr);
        this.demandData.custom_user_mvr = _.cloneDeep(this.demandService.demandModel.custom_user_mvr);
        this.demandData.custom_mvr = _.cloneDeep(this.demandService.demandModel.custom_mvr);
      }

      if ($event === 4) {
        if (!this.demandService.bidders || !this.demandService.bidders.length) {
          this.fetchBiddersFromJSON().then(() => {
            return;
          });
        }
      }
    }
  }

  onDemandSubTypeChange($event: any) {
    if ($event === TYPE_DISPLAY && this.isPartner('google')) {
      this.demandData.vast_url = 'https://pubads.g.doubleclick.net/gampad/ads?iu=';
    }

    this.demandSubType = $event;

    this.updateExtraParams({ demand_sub_type: $event });
  }

  getVastCPM() {
    let vast_cpm = 0;
    if (this.demandData.vast_cpm) {
      vast_cpm = this.demandData.vast_cpm;
    } else if (this.getDemandResponse.vast_cpm) {
      vast_cpm = this.getDemandResponse.vast_cpm;
    }
    return parseFloat(vast_cpm.toString());
  }

  fetchBiddersFromJSON(): Promise<void> {
    return new Promise((resolve) => {
      this.subscriptions.push(
        this.httpService.get('/templates/prebid-demand.json', {}, false).subscribe((response: any) => {
          if (response && response.networks && response.adapters) {
            this.demandService.bidderConfs = {};
            const networkConf = this.findNetworkBidderConfig(
              response.networks,
              this.userService.networkData.networkId
            );

            // No matching network and no Default (*) → allow all known bidders
            if (!networkConf) {
              this.demandService.biddersAllowed = _.cloneDeep(this.demandService.bidders);
              resolve();
              return;
            }

            const thisNetworkConf = this.resolveNetworkBidderAllowList(response.networks, networkConf);

            Object.keys(response.adapters).forEach((key) => {
              // Load config only in case if it available for network
              if (
                thisNetworkConf.length &&
                response.adapters[key]['bidder'] &&
                (thisNetworkConf.includes(response.adapters[key]['bidder']) || thisNetworkConf.includes(key))
              ) {
                this.addPrebidAdapterConfig(response.adapters[key], key);
              }
            });
          } else {
            this.demandService.biddersAllowed = _.cloneDeep(this.demandService.bidders);
          }

          resolve();
        })
      );
    });
  }

  findNetworkBidderConfig(networks: any, networkId: string | number): any {
    if (!Array.isArray(networks) || !networks.length) {
      return null;
    }

    const matched = _.find(networks, (n) => String(n.id) === String(networkId));
    if (matched) {
      return matched;
    }

    return _.find(networks, (n) => String(n.id) === '*') || null;
  }

  /**
   * Resolve effective bidder allow-list for a network config entry.
   * `allow` may include `*` (expand to Default / id:"*" allow list).
   * `block` always wins over allow.
   */
  resolveNetworkBidderAllowList(networks: any, networkConf: any): string[] {
    if (!networkConf) {
      return [];
    }

    const defaultNetwork = Array.isArray(networks)
      ? _.find(networks, (n) => String(n.id) === '*')
      : null;
    const defaultAllow: string[] = ((defaultNetwork && defaultNetwork.allow) || []).filter(
      (item: string) => item !== '*'
    );
    const allowed = new Set<string>();

    (networkConf.allow || []).forEach((item: string) => {
      if (item === '*') {
        defaultAllow.forEach((bidder) => allowed.add(bidder));
      } else if (item) {
        allowed.add(item);
      }
    });

    (networkConf.block || []).forEach((item: string) => {
      allowed.delete(item);
    });

    return Array.from(allowed);
  }

  addPrebidAdapterConfig(adapter: any, key: string): void {
    const bidderFromService: any = _.find(this.demandService.bidders, { alias: adapter['bidder'] });
    if (bidderFromService) {
      if (!_.find(this.demandService.biddersAllowed, { value: bidderFromService.value })) {
        this.demandService.biddersAllowed.push(bidderFromService);
      }

      this.demandService.bidderConfs[key] = this.buildBidderKeys(adapter);
    }
  }

  buildBidderKeys(adapterValue: any): any {
    let templateJSONstring: string = adapterValue['paramsJSON'];
    let templateJSON: any = {};
    let replaceVal: any = null;
    const matching: any = {
      bidder: adapterValue['bidder'],
      keys: this.parseJSONKeys(adapterValue['macros']),
      template: adapterValue['paramsJSON'],
      macrosKeys: {},
    };

    Object.keys(adapterValue['macros']).forEach((key) => {
      replaceVal = this.sharedService.generateRandomNumber(20);
      matching.macrosKeys[key] = {
        replacement: replaceVal,
        objKeys: [],
      };
      templateJSONstring = templateJSONstring.split(`[${key}]`).join(replaceVal);
    });

    templateJSON = eval(`(${templateJSONstring})`);

    Object.keys(matching.macrosKeys).forEach((key) => {
      matching.macrosKeys[key] = this.getJSONMatchedKeys(templateJSON, matching.macrosKeys[key]['replacement']);
    });

    for (let i = 0; i < matching.keys.length; i++) {
      const expectsString =
        matching.keys[i]['type'] === 'string' ||
        (matching.keys[i]['type'] === 'select' && matching.keys[i]['optionsType'] === 'string');
      if (expectsString) {
        if (
          typeof this.demandService.deepValue(
            templateJSON,
            matching.macrosKeys[matching.keys[i]['name']][0]['path']
          ) !== 'string'
        ) {
          matching.template = this.dictionaryService.get('INCORRECt_JSON_TEMPLATE');
        }
      } else {
        if (
          typeof this.demandService.deepValue(
            templateJSON,
            matching.macrosKeys[matching.keys[i]['name']][0]['path']
          ) === 'string'
        ) {
          matching.template = this.dictionaryService.get('INCORRECt_JSON_TEMPLATE');
        }
      }
    }

    return matching;
  }

  getJSONMatchedKeys(templateJSON: any, ident: string | number, parent = null): any[] {
    let resp: any[] = [];
    Object.keys(templateJSON).forEach((key) => {
      if (typeof templateJSON[key] === 'object') {
        parent = parent ? `${parent}.${key}` : key;
        resp = [...resp, ...this.getJSONMatchedKeys(templateJSON[key], ident, parent)];
      } else {
        if (templateJSON[key] === ident || templateJSON[key].toString().includes(ident)) {
          resp.push({
            path: parent ? `${parent}.${key}` : key,
            exactMatch: templateJSON[key].toString() === ident.toString(),
            template:
              templateJSON[key].toString() === ident.toString()
                ? null
                : templateJSON[key].toString().split(`${ident}`).join('[template]'),
          });
        }
      }
    });
    return resp;
  }

  parseJSONKeys(defaults: any): any[] {
    let value: any;
    let oneProp: any;
    const res: any = [];

    Object.keys(defaults).forEach((key) => {
      value = defaults[key];
      oneProp = { name: key };

      // Simple Input without extra options
      if (typeof value !== 'object') {
        oneProp.type = ['true', 'false'].includes(value.toString()) ? 'boolean' : typeof value;
        oneProp.defaultVal = value;
      } else {
        // Selects
        if (value.options) {
          oneProp.type = 'select';
          oneProp.options = [];
          Object.keys(value.options).forEach((key) => {
            oneProp.options.push({
              label: key,
              value: value.options[key],
            });
          });
          oneProp.optionsType = typeof oneProp.options[0]['value']; // 'string' | 'number'
          oneProp.defaultVal = oneProp.options[0]['value'];

          // Input with extra options
        } else {
          oneProp.type = ['true', 'false'].includes(value.default.toString()) ? 'boolean' : typeof value.default;
          oneProp.defaultVal = value.default;
          oneProp.tooltip = value.tooltip ? value.tooltip : '';
        }
      }

      res.push(oneProp);
    });

    return res;
  }

  /**
   * Prebid Server expects `placement_id`; client Prebid uses `placementId` for appnexus params.
   */
  private patchAppNexusAdaptersForPbserver(adapters: any[]): void {
    if (!adapters.length || !this.experimentalFeatures.pbserver) {
      return;
    }
    const idx = adapters.findIndex((a) => a.label === APPNEXUS_PB_BIDDER_NAME);
    if (idx === -1) {
      return;
    }
    const spec = {
      bidder: APPNEXUS_PB_BIDDER_NAME,
      paramsJSON: `{${APPNEXUS_PBS_PLACEMENT_PARAM}: [PlacementId]}`,
      macros: {
        PlacementId: {
          default: 0,
          tooltip: 'PlacementID',
        },
      },
    };
    adapters[idx] = this.buildBidderKeys(spec);
    adapters[idx].label = APPNEXUS_PB_BIDDER_NAME;
    adapters[idx].value = APPNEXUS_PB_BIDDER_NAME;
  }

  private migrateAppNexusBidderJson(jsonString: string): string {
    if (!jsonString || jsonString === '{}') {
      return jsonString;
    }
    let json: any;
    try {
      json = JSON.parse(jsonString);
    } catch {
      return jsonString;
    }
    if (this.experimentalFeatures.pbserver) {
      if (APPNEXUS_PBJS_PLACEMENT_PARAM in json && !(APPNEXUS_PBS_PLACEMENT_PARAM in json)) {
        json.placement_id = json.placementId;
        delete json.placementId;
      }
    } else {
      if (APPNEXUS_PBS_PLACEMENT_PARAM in json && !(APPNEXUS_PBJS_PLACEMENT_PARAM in json)) {
        json.placementId = json.placement_id;
        delete json.placement_id;
      }
    }
    return JSON.stringify(json, null, this.sharedService.formatJSONstring);
  }

  toggleEnvironment(environment: string) {
    this.demandData[environment] = !this.demandData[environment];
  }

  viewAvailableMacros(type: string) {
    this.modalsService.showModal({
      component: 'available-macros',
      title: this.dictionaryService.get('AVAILABLE_MACROS'),
      data: {
        type: type,
      },
    });
  }

  getSelectedPartner() {
    const item: any = _.find(this.partners, { value: +this.demandData.partnerId });
    let index = -1;
    if (item) {
      index = this.partners.indexOf(item);
      if (index !== -1) {
        return index;
      }
    }
    return index;
  }

  getSelectedSchainIndex() {
    if (!this.demandData.targeting.schains) {
      return -1;
    }
    const item: any = _.find(this.schainsForDropdown, { id: this.demandData.targeting.schains.id });
    if (item) {
      return this.schainsForDropdown.indexOf(item);
    }
    return -1;
  }

  onSchainSelect(event: any) {
    if (event && event.value !== undefined) {
      const originalSchain = _.find(this.sharedService.targetingLookups.schains, { id: event.value });
      this.demandData.targeting.schains = originalSchain || null;
    } else {
      this.demandData.targeting.schains = null;
    }
  }

  getDemandOwnerType() {
    for (let i = 0; i < this.demandOwnerTypes.length; i++) {
      if (this.demandOwnerTypes[i].value === this.experimentalFeatures.demandOwner) {
        return i;
      }
    }
    return -1;
  }
  filterBidders(bidders) {
    if (this.userService.isAdmin()) {
      return bidders;
    }

    if (this.userService.isOem()) {
      this.oemPrebidBidders = bidders.filter((bidder) =>
        this.oemPrebidBiddersAllowed.includes(bidder.alias.toLowerCase())
      );
      return this.oemPrebidBidders;
    }
    return bidders;
  }
  getSelectedBidder() {
    let index = -1;
    if (!this.demandData.bidder || !this.demandData.bidder.bidderId) {
      return index;
    }

    const item: any = _.find(this.demandService.biddersAllowed, { value: +this.demandData.bidder.bidderId });

    if (item) {
      index = this.demandService.biddersAllowed.indexOf(item);
      if (index !== -1) {
        return index;
      }
    }

    return index;
  }

  isBidderListDisabled(): boolean {
    let find: any;

    if (
      !this.demandData['bidder'] ||
      !this.demandData['bidder']['bidderId'] ||
      +this.demandData['bidder']['bidderId'] < 1
    ) {
      return this.editMode;
    }

    find = _.find(this.demandService.biddersAllowed, { value: +this.demandData['bidder']['bidderId'] });
    return !find || !find['alias'];
  }

  onPartnerSelect($event) {
    if ($event === null) {
      this.demandData.partnerId = null;
      this.demandData.partnerName = null;
    } else {
      if ($event.value === -1) {
        this.demandData.partnerId = -1;
        this.demandData.partnerName = $event.label;
        this.partners.push($event);
      } else {
        this.demandData.partnerId = $event.value;
        this.demandData.partnerName = null;
      }
    }

    this.applyExcoGooglePartnerDefaults();

    if (this.isPartner('display')) {
      this.demandSubType = TYPE_DISPLAY;
    } else if (this.isPartner('google')) {
      this.demandSubType = this.demandSubType || TYPE_VIDEO;
    } else {
      this.demandSubType = null;
    }
  }

  /**
   * New Exco + Google demands default floor CPM to $1 and GKV on.
   * Values stay editable after they are applied.
   */
  applyExcoGooglePartnerDefaults() {
    if (this.editMode || this.duplicateMode) {
      return;
    }

    const networkId = this.userService.networkData && this.userService.networkData.networkId;
    if (+networkId !== EXCO_NETWORK_ID || +this.demandData.partnerId !== GOOGLE_PARTNER_ID) {
      return;
    }

    this.demandData.vast_cpm = EXCO_GOOGLE_DEFAULT_FLOOR_CPM;
    this.googleKeyValueEnabled = true;
    this.updateExtraParams({ gkv: true });
  }

  getPartnerName(): string {
    const partner = this.partners.find((partner) => partner.value === this.demandData.partnerId) || {};
    return partner.label;
  }

  onDemandOwnerSelect($event) {
    if ($event === null) {
      this.demandData.partnerId = null;
      this.demandData.partnerName = null;
    } else {
      if ($event.value === -1) {
        this.demandData.partnerId = -1;
        this.demandData.partnerName = $event.label;
        this.partners.push($event);
      } else {
        this.demandData.partnerId = $event.value;
        this.demandData.partnerName = null;
      }
    }
  }

  onBidderSelect($event) {
    const jsonString = '{}';
    if (!this.demandData.bidder) {
      this.demandData.bidder = {};
    }
    if ($event === null) {
      this.demandData.bidder.bidderId = null;
      this.demandData.bidder.json = jsonString;
    } else {
      if ($event.value === -1) {
        this.demandData.bidder.bidderId = -1;
        this.demandData.bidder.name = $event.label;
        this.demandData.bidder.json = jsonString;
      } else {
        this.demandData.bidder.name = $event.label;
        this.demandData.bidder.bidderId = $event.value;
        this.fillBidderConf($event);
      }
    }

    if (this.demandData.bidder.name === 'Boldwin') {
      this.onPrebidOemPlacementParams({ value: 5 }, 'plcmtOem', 'placement');
      this.onPrebidOemPlacementParams({ value: 3 }, 'plcmtOem', 'plcmt');
    }
  }

  fillBidderConf($event) {
    this.demandData.bidder.conf = {};
    this.demandData.bidder.conf.adapters = [];

    _.map(this.demandService.bidderConfs, (val, key) => {
      if (val.bidder === $event.alias) {
        const valCopy = _.cloneDeep(val);
        delete valCopy.bidder;
        valCopy.label = key;
        valCopy.value = key;
        this.demandData.bidder.conf.adapters.push(valCopy);
      }
    });

    if ($event.value === APPNEXUS_PREBID_BIDDER_ID) {
      this.patchAppNexusAdaptersForPbserver(this.demandData.bidder.conf.adapters);
      this.demandData.bidder.json = this.migrateAppNexusBidderJson(this.demandData.bidder.json || '{}');
    }

    if (this.demandData.bidder.conf) {
      this.demandData.bidder.conf.rebuildJSON = !this.editMode;
      this.demandData.bidder.conf.currentAdapter = _.cloneDeep(this.demandData.bidder.conf.adapters[0]);
    }
  }

  updateBidderJSON(json: string): void {
    this.demandData.bidder.json = json;
  }

  onPrebidJsonChanged($event) {
    if (this.sharedService.isJSON($event.target.value)) {
      this.demandData.bidder.json = $event.target.value;
      this.errorInputs = _.remove(this.errorInputs, 'bidder');
    } else {
      this.errorInputs.push('bidder');
    }
    this.errorInputs = _.uniq(this.errorInputs);
  }

  goToCxPlayer() {
    this.router.navigate(['/supply/manage/' + this.demandData.subPlayerId]).then(() => {
      return;
    });
  }

  verifyNetworkForCedatoX() {
    if (
      !this.sharedService.isEmpty(this.demandData.parentNetworkId) &&
      this.sharedService.isNumeric(this.demandData.parentNetworkId)
    ) {
      if (this.demandData.parentNetworkId !== this.parentNetworkIdOnFocus) {
        this.verifyNetworkForCedatoXLoading = true;
        this.verifyNetworkForCedatoXConfirmed = false;
        this.subscriptions.push(
          this.httpService
            .post('vdsp_ws/verifyNetworkForCedatoX', { affiliate_network_id: this.demandData.parentNetworkId })
            .subscribe((response) => {
              if (response.status === 'OK') {
                this.demandData.parentNetworkName = response.network.affiliate_network_name;
                this.modalsService.showModal({
                  title: this.dictionaryService.get('CEDATOX_CONNECTION'),
                  component: 'cedatox-confirm',
                  data: {
                    networkId: response.network.affiliate_network_id,
                    networkName: response.network.affiliate_network_name,
                  },
                });
              } else {
                this.sharedService.showFlashMessage(response.error, 'error');
                this.verifyNetworkForCedatoXConfirmed = false;
                this.demandData.partnerNetworkId = '';
                this.demandData.partnerNetworkName = '';
              }
              this.verifyNetworkForCedatoXLoading = false;
            })
        );
      }
    } else {
      this.demandData.parentNetworkId = null;
      this.demandData.parentNetworkName = '';
      this.verifyNetworkForCedatoXConfirmed = false;
    }
  }

  onPartnerNetworkIdChange() {
    if (this.sharedService.isEmpty(this.demandData.parentNetworkId)) {
      this.verifyNetworkForCedatoXConfirmed = false;
    }
  }

  onTargetingChange(items: any, type: string) {
    let versions;
    switch (type) {
      case 'browsers':
        for (let i = 0; i < items.length; i++) {
          versions = this.getBrowserVersions(items[i].name);
          if (items[i].from === undefined) {
            items[i].from = versions[0];
          }
          if (items[i].to === undefined) {
            items[i].to = versions[versions.length - 1];
          }
        }
        break;
      case 'os':
        for (let i = 0; i < items.length; i++) {
          versions = this.getOSVersions(items[i].name);
          if (items[i].from === undefined) {
            items[i].from = versions[0];
          }
          if (items[i].to === undefined) {
            items[i].to = versions[versions.length - 1];
          }
        }
        break;
      case 'location':
      case 'dma':
      case 'state':
        if (!this.isTargetingDMAEnabled()) {
          if (this.targeting.dma) {
            this.sharedService.showFlashMessage(this.dictionaryService.get('DMA_DISABLED_POPUP'), 'warning');
          }
          this.targeting.dma = false;
          this.demandData.targeting.dma.type = 0;
          this.demandData.targeting.dma.list = [];
        }
        if (!this.isTargetingStatesEnabled()) {
          // Here add states things to do when toggle change
          this.targeting.state = false;
          this.demandData.targeting.state.type = 0;
          this.demandData.targeting.state.list = [];
        }
        break;
      case 'timeTargeting':
        if (!this.targeting.timeTargeting) {
          this.demandData.targeting.time_targeting.list = [];
        }
        break;
      case 'ivt':
      case 'viewability':
        if (this.demandData.targeting[`${type}_enabled`]) {
          this.demandData.targeting[`${type}_ispass`] = this.userService.getFeatureState(`${type}_ispass`) ? 1 : 0;
        }
    }
  }

  isTargetingStatesEnabled(): boolean {
    const isLocationTypeInclude = this.demandData.targeting.location.type == 1;
    const USincluded = typeof _.find(this.demandData.targeting.location.list, { iso: 'US' }) !== 'undefined';
    const isTargetingDMAEnabled = this.targeting.dma;
    const result = isLocationTypeInclude == USincluded && this.targeting.location && !isTargetingDMAEnabled;

    if (!result) {
      this.demandData.targeting.state.type = 0;
      this.demandData.targeting.state.list = [];
    }
    return result;
  }

  isTargetingDMAEnabled(): boolean {
    const isLocationTypeInclude = this.demandData.targeting.location.type == 1;
    const USincluded = typeof _.find(this.demandData.targeting.location.list, { iso: 'US' }) !== 'undefined';
    const isTargetingStatesEnabled = this.targeting.state;
    const result = isLocationTypeInclude == USincluded && this.targeting.location && !isTargetingStatesEnabled;
    if (!result) {
      this.demandData.targeting.dma.type = 0;
      this.demandData.targeting.dma.list = [];
    }
    return result;
  }

  getBrowserVersions(browserName) {
    const browser = _.find(this.sharedService.targetingLookups.browserVersions, { name: browserName });
    const versions = browser.versions.split(',');
    for (let i = 0; i < versions.length; i++) {
      versions[i] = versions[i].trim();
    }
    versions.push(this.dictionaryService.get('LATEST'));
    return versions;
  }

  getOSVersions(osName) {
    const os = _.find(this.sharedService.targetingLookups.osVersions, { name: osName });
    const versions = os.versions.split(',');
    for (let i = 0; i < versions.length; i++) {
      versions[i] = versions[i].trim();
    }
    versions.push(this.dictionaryService.get('LATEST'));
    return versions;
  }

  getCustomPlayerSizeRestrictions() {
    return _.filter(this.demandData.targeting.targetingSizes.list, { custom: true });
  }

  onPostBidValueToggle(property: string) {
    this.demandData.targeting[property] = !this.demandData.targeting[property];
    if (this.demandData.targeting[property]) {
      this.subscriptions.push(
        this.httpService.post('vdsp_ws/getNetworkIvt').subscribe(
          (response: any) => {
            const ivt: Array<any> = _.filter(response, { ivt_partner_id: '1' });
            let optIn = false;
            if (ivt.length > 0) {
              if (+ivt[0].rate >= 10) {
                optIn = true;
              }
            }
            if (!optIn) {
              this.demandData.targeting[property] = false;
              this.modalsService.showModal({
                component: 'postbid-alert',
                title: this.dictionaryService.get('IVT_TARGETING_ITEMS'),
              });
            }
          },
          () => {
            this.sharedService.showErrorFlashMessage();
          }
        )
      );
    }
  }

  getCappingPlaceholder(id: number) {
    let placeholder: string = this.dictionaryService.get('MIN') + '. ';
    switch (id) {
      case 1:
        placeholder += this.demandService.cappingLimits.demand_min_imp_even.toLocaleString();
        break;
      case 2:
        placeholder +=
          this.demandData.vast_capping[2].paceOption === 1
            ? this.demandService.cappingLimits.demand_min_adr_asap.toLocaleString()
            : this.demandService.cappingLimits.demand_min_adr_even.toLocaleString();
        break;
      default:
        placeholder += this.demandService.cappingLimits.demand_min_user_ip.toLocaleString();
    }
    return placeholder;
  }

  onCappingChange(id: number, value: any) {
    const num: number = this.sharedService.strToInt(value);
    this.demandData.vast_capping[id].cappingValue = num ? this.sharedService.toLocaleString(num) : '';
  }

  getCallbackEvents(currItem: any) {
    const availableCallbacks: Array<any> = [];
    let isAvailable: boolean;
    let callbacksOfCurrType: Array<any>;
    this.eventsList = [];
    for (let i = 0; i < this.demandService.eventsList.length; i++) {
      isAvailable = false;
      if (this.demandService.eventsList[i].featureFlag) {
        if (this.userService.getFeatureState(this.demandService.eventsList[i].featureFlag)) {
          isAvailable = true;
        }
      } else {
        isAvailable = true;
      }
      if (isAvailable) {
        callbacksOfCurrType = _.filter(this.demandData.callbacks, { event: this.demandService.eventsList[i] });
        if (callbacksOfCurrType.length < 2 || currItem.event === this.demandService.eventsList[i]) {
          availableCallbacks.push(this.demandService.eventsList[i]);
        }
      }
    }
    return availableCallbacks;
  }

  getAvailableCallbacks() {
    const currCallbacks: Array<number> = _.map(this.demandData.callbacks, 'event');
    const availableCallbacks: Array<number> = [];
    for (let i = 0; i < this.demandService.eventsList.length; i++) {
      if (
        _.filter(currCallbacks, {
          eventId: this.demandService.eventsList[i].eventId,
          typeId: this.demandService.eventsList[i].typeId,
        }).length < 2
      ) {
        availableCallbacks.push(this.demandService.eventsList[i]);
      }
    }
    return availableCallbacks;
  }

  addCallback() {
    this.demandData.callbacks.push({ url: '', event: this.getAvailableCallbacks()[0], rate: 100 });
  }

  removeCallback(callbackIndex: number) {
    this.demandData.callbacks.splice(callbackIndex, 1);
  }

  stringifyTimeTargeting(timeTargetingData: any) {
    const day = this.sharedService.targetingLookups.weekDays.indexOf(timeTargetingData.day);
    const fromHour = this.originalTargetingDayFromHourList.indexOf(timeTargetingData.fromHour.Value);
    const toHour = this.originalTargetingDayToHourList.indexOf(timeTargetingData.toHour.Value) + 1;
    if (day == -1 || fromHour == -1 || toHour == -1) {
      return false;
    } else {
      return day + ':' + fromHour + '-' + toHour;
    }
  }

  parseTimeTargetingString(timeTargetingString: string) {
    const regex = /(?:([0-7]):(1[0-9]|2[0-3]|[0-9])-(1[0-9]|2[0-4]|[0-9]))/m;
    const matches = regex.exec(timeTargetingString);
    if (matches !== null) {
      const dayNo: number = +matches[1];
      const from: number = +matches[2];
      const to: number = +matches[3];
      return {
        day: this.sharedService.targetingLookups.weekDays[dayNo],
        fromHour: {
          Value: this.originalTargetingDayFromHourList[from],
          Options: [],
        },
        toHour: {
          Value: this.originalTargetingDayToHourList[to - 1],
          Options: [],
        },
      };
    }
  }

  validateTargeting() {
    let valid = true;
    let compareResult: number;
    const customPlayerSizeRestrictions: Array<any> = this.getCustomPlayerSizeRestrictions();
    if (this.demandData.targeting.location.type !== 0 && this.demandData.targeting.location.list.length === 0) {
      this.errorInputs.push('targetingLocation');
      valid = false;
    }

    if (this.demandData.targeting.state.type !== 0 && this.demandData.targeting.state.list.length === 0) {
      this.errorInputs.push('targetingStates');
      valid = false;
    }
    if (this.demandData.targeting.browsers.type !== 0) {
      if (this.demandData.targeting.browsers.list.length === 0) {
        this.errorInputs.push('targetingBrowsers');
        valid = false;
      } else {
        for (let i = 0; i < this.demandData.targeting.browsers.list.length; i++) {
          if (this.demandData.targeting.browsers.list[i].to.toLowerCase() !== 'latest') {
            compareResult = this.sharedService.versionCompare(
              this.demandData.targeting.browsers.list[i].from,
              this.demandData.targeting.browsers.list[i].to
            );
            if (_.isNaN(compareResult) || compareResult > 0) {
              this.errorInputs.push('targetingBrowsersFromTo');
              valid = false;
            }
          }
        }
      }
    }
    if (this.demandData.targeting.os.type !== 0) {
      if (this.demandData.targeting.os.list.length === 0) {
        this.errorInputs.push('targetingOS');
        valid = false;
      } else {
        for (let i = 0; i < this.demandData.targeting.os.list.length; i++) {
          if (this.demandData.targeting.os.list[i].to.toLowerCase() !== 'latest') {
            compareResult = this.sharedService.versionCompare(
              this.demandData.targeting.os.list[i].from,
              this.demandData.targeting.os.list[i].to
            );
            if (_.isNaN(compareResult) || compareResult > 0) {
              this.errorInputs.push('targetingOSFromTo');
              valid = false;
            }
          }
        }
      }
    }

    if (
      this.demandData.targeting.targetingSizes.type !== 0 &&
      this.demandData.targeting.targetingSizes.list.length === 0
    ) {
      this.errorInputs.push('targetingSize');
      valid = false;
    }
    for (let i = 0; i < customPlayerSizeRestrictions.length; i++) {
      if (
        customPlayerSizeRestrictions[i].width < 1 ||
        customPlayerSizeRestrictions[i].width > 99999 ||
        customPlayerSizeRestrictions[i].height < 1 ||
        customPlayerSizeRestrictions[i].height > 99999
      ) {
        this.errorInputs.push('targetingSizeWidthHeight');
        valid = false;
      }
    }
    if (this.demandData.targeting.dma.type !== 0 && this.demandData.targeting.dma.list.length === 0) {
      this.errorInputs.push('targetingDMA');
    }
    // let's check if day targeting is valid
    const hasInValidDayParting = _.includes(
      _.map(this.demandData.targeting.time_targeting.list, (dayPart) => {
        return this.stringifyTimeTargeting(dayPart);
      }),
      false
    );
    if (hasInValidDayParting) {
      this.errorInputs.push('targetingDayParting');
      valid = false;
    }
    if (!valid) {
      this.errorInputs.push('targeting');
    }
    return valid;
  }

  validateForm() {
    let valid = true;
    let autoFocusURL = false;
    this.errorInputs = [];

    this.demandData.callbacks.forEach((callback: any) => {
      callback.url = callback.url.replace(' ', '%20');
    });
    if (this.sharedService.isEmpty(this.demandData.vast_name)) {
      valid = false;
      this.errorInputs.push('demandName');
    }
    if (
      !(
        this.demandData.is_desktop ||
        this.demandData.is_mobile_web ||
        this.demandData.is_mobile_app ||
        this.demandData.is_ctv
      )
    ) {
      valid = false;
      this.errorInputs.push('environment');
    }
    if (this.demandData.type === 0 && this.sharedService.isEmpty(this.demandData.vast_url)) {
      valid = false;
      this.errorInputs.push('missingURL');
      autoFocusURL = true;
    } else if (this.demandData.type === 0 && !this.sharedService.validateURL(this.demandData.vast_url)) {
      valid = false;
      this.errorInputs.push('invalidURL');
      autoFocusURL = true;
    }
    if (
      this.demandData.type === 0 &&
      (this.sharedService.isEmpty(this.demandData.vast_cpm) || this.demandData.vast_cpm < 0.01)
    ) {
      valid = false;
      this.errorInputs.push('CPM');
    }
    if (
      this.demandData.type === 3 &&
      (this.sharedService.isEmpty(this.demandData.floorCPM) || this.demandData.floorCPM < 0.01)
    ) {
      valid = false;
      this.errorInputs.push('floorCPM');
    }
    if (this.demandData.type === 3 && this.demandData.rtb_vendor < 1) {
      valid = false;
      this.errorInputs.push('rtbVendor');
    }
    if (
      this.dynamicDemand &&
      (this.sharedService.isEmpty(this.pushPercentage) || this.pushPercentage < 0.01 || this.pushPercentage > 1)
    ) {
      valid = false;
      this.errorInputs.push('pushPercentage');
    }
    if (!this.sharedService.isEmpty(this.maxDuration) && this.maxDuration < 0.01) {
      valid = false;
      this.errorInputs.push('maxDuration');
    }

    if (this.demandData.type !== 1 && this.userService.isAdmin() && this.demandData.extra_params_enabled) {
      if (!this.validateExtraParams()) {
        valid = false;
      }
    }
    // Bidder configuration
    if (
      this.demandData.type == 4 &&
      !this.sharedService.isJSON(this.demandData.bidder.json) &&
      this.demandData.bidder.json != '{}'
    ) {
      valid = false;
      this.errorInputs.push('bidder');
    }

    // Premium demand enabled for SupplyX
    // Premium demand SupplyX validation
    // if (this.demandData.premium && this.hasSupplyXAssigned()) {
    //   this.errorInputs.push('premium');
    //   valid = false;
    // }
    if (this.demandData.type === 1 && !this.verifyNetworkForCedatoXConfirmed && !this.editMode) {
      valid = false;
      this.errorInputs.push('partnerNetworkId');
    }
    if (this.demandData.domainListType !== 0 && this.demandData.domainLists.length === 0) {
      valid = false;
      this.errorInputs.push('domainLists');
    }
    if (this.demandData.urlListType !== 0 && this.demandData.urlLists.length === 0) {
      valid = false;
      this.errorInputs.push('urlLists');
    }
    if (this.demandData.ipListType !== 0 && this.demandData.ipLists.length === 0) {
      valid = false;
      this.errorInputs.push('ipLists');
    }
    if (this.demandData.domainListType !== 0 && this.demandData.domainLists.length > this.demandService.listsLimit) {
      valid = false;
      this.errorInputs.push('domainListsLimit');
    }
    if (this.demandData.ipListType !== 0 && this.demandData.ipLists.length > this.demandService.ipListsLimit) {
      valid = false;
      this.errorInputs.push('ipListsLimit');
    }
    if (!this.callbacksService.validateNoEmptyCallbacks(this.demandData.callbacks)) {
      valid = false;
      this.errorInputs.push('callbacksEmpty');
    } else if (!this.callbacksService.validatCallbacksURLs(this.demandData.callbacks)) {
      valid = false;
      this.errorInputs.push('callbacksURL');
    }
    if (!this.callbacksService.validateIVTCallbacks(this.demandData.callbacks)) {
      valid = false;
      this.errorInputs.push('callbacksIVT');
    }
    if (!this.callbacksService.validateUniqueCallbacks(this.demandData.callbacks)) {
      valid = false;
      this.errorInputs.push('callbacksDoubled');
    }
    if (!this.callbacksService.validateCallbacksRates(this.demandData.callbacks)) {
      valid = false;
      this.errorInputs.push('callbacksRate');
    }
    if (!this.validateTargeting()) {
      valid = false;
    }
    // Adding additional checking for targeting vendor domain. But warning will appear in restrictions
    if (this.demandData.targeting.vast_domains.type !== 0) {
      const anyInvalidDomains =
        this.demandData.targeting.vast_domains.list.filter((domain) => {
          return !this.sharedService.validateURL(domain);
        }).length > 0;
      if (anyInvalidDomains) {
        valid = false;
        this.errorInputs.push('vendor_blacklist');
      }
    }
    if (
      this.demandData.targeting.viewability_enabled &&
      (this.demandData.targeting.viewability < 1 || this.demandData.targeting.viewability > 100)
    ) {
      valid = false;
      this.errorInputs.push('viewability');
      this.errorInputs.push('targeting');
    }
    if (
      this.demandData.targeting.ivt_enabled &&
      (this.demandData.targeting.ivt < 1 || this.demandData.targeting.ivt > 100)
    ) {
      valid = false;
      this.errorInputs.push('ivt');
      this.errorInputs.push('targeting');
    }
    if (
      this.demandData.type !== 1 &&
      (this.demandData.custom_user_mvr == 0 ||
        this.demandData.custom_user_mvr > this.customMVRCappingLimit ||
        this.sharedService.isEmpty(this.demandData.custom_user_mvr)) &&
      this.demandData.custom_mvr
    ) {
      valid = false;
      this.errorInputs.push('user_mvr');
    }
    // if (this.demandData.premium && this.experimentalFeatures.forceGPV) {
    //   valid = false;
    //   this.errorInputs.push('premium_boost');
    // }
    if (
      (this.experimentalFeatures.priceFactor && this.experimentalFeatures.priceFactor < 1) ||
      this.experimentalFeatures.priceFactor > 100
    ) {
      valid = false;
      this.errorInputs.push('priceFactor');
    }
    if (this.isGoogleMacroSuppressionInvalid()) {
      valid = false;
      this.errorInputs.push('googleMacroSuppression');
    }

    this.errorInputs = _.uniq(this.errorInputs);
    if (!valid) {
      this.sharedService.onEntitySaveFailure();
      if (autoFocusURL && document.getElementById('vastURL')) {
        document.getElementById('vastURL').focus();
      }
    }
    return valid;
  }

  validateExtraParams() {
    let valid = true;
    this.errorInputs = _.without(this.errorInputs, 'extra_params', 'extra_params_not_defined', 'extra_params_too_long');

    if (!this.sharedService.isJSON(this.demandData.extra_params)) {
      valid = false;
      this.errorInputs.push('extra_params');
    } else {
      if (
        stringify(JSON.parse(this.demandData.extra_params)) ===
        stringify(JSON.parse(this.demandService.extraParamsDefaultValue.json))
      ) {
        valid = false;
        this.errorInputs.push('extra_params_not_defined');
      } else if (
        stringify(JSON.parse(this.demandData.extra_params)).length >
        +this.demandService.extraParamsDefaultValue.extra_params_length
      ) {
        this.errorInputs.push('extra_params_too_long');
        valid = false;
      }
    }
    this.errorInputs = _.uniq(this.errorInputs);
    return valid;
  }

  cancel() {
    this.router.navigate(['/demand/manage']).then(() => {
      return;
    });
  }

  onExtraParamToggleChange($event) {
    const extraParamsSectionItem: any = _.find(this.allSections, { value: 'extraParams' });
    if (!$event) {
      const parsed = this.parseExtraParams(this.demandService.extraParamsDefaultValue.json);
      this.demandData.extra_params = stringify(
        Object.assign(
          {},
          parsed,
          {
            dynamic_demand: this.dynamicDemand,
            push_percentage: this.pushPercentage,
          },
          this.experimentalFeatures
        ),
        { space: this.sharedService.formatJSONstring }
      );
    }
    this.demandData.extra_params_enabled = $event;
    if (extraParamsSectionItem) {
      extraParamsSectionItem.onIf = this.demandData.extra_params_enabled;
    }
  }

  freqCappingChanged(id: number = 0) {
    if ([3, 4].includes(id)) {
      this.demandData.vast_capping[id].active = !this.demandData.vast_capping[id].active;

      if (
        (!this.viewVars.isCappingUserFreq ||
          (this.viewVars.isCappingUserFreq && !this.demandData.vast_capping[3].active)) &&
        (!this.viewVars.isCappingIPFreq || (this.viewVars.isCappingIPFreq && !this.demandData.vast_capping[4].active))
      ) {
        if (this.mvrTmpStore.isChanged) {
          this.demandData.user_mvr = this.mvrTmpStore.user_mvr;
          this.demandData.custom_user_mvr = this.mvrTmpStore.custom_user_mvr;
        }
        this.isFreqCappingEnabled = false;
      } else {
        if (this.demandData.user_mvr !== 1) {
          this.mvrTmpStore = {
            user_mvr: _.cloneDeep(this.demandData.user_mvr),
            custom_user_mvr: _.cloneDeep(this.demandData.custom_user_mvr),
            isChanged: true,
          };
          this.demandData.user_mvr = 1;
          this.demandData.custom_user_mvr = 1;
        }
        this.isFreqCappingEnabled = true;
      }
    }
  }

  userMVRChanged($event: number) {
    this.demandData.user_mvr = $event;
    this.mvrTmpStore.user_mvr = $event;
  }

  extractIds = (list: ListItem[]) => {
    return list.reduce((acc, item) => {
      if (item.id !== null && item.id !== undefined) {
        return acc ? `${acc},${item.id}` : `${item.id}`;
      }
      return acc;
    }, '');
  };

  save(close: boolean = false) {
    const noErrors: boolean = this.validateForm();
    const demandToSave: any = {};
    const targeting: any = {};
    const domainLists: Array<any> = [];
    const urlLists: Array<any> = [];
    const ipLists: Array<any> = [];
    const vast_capping: Array<any> = [];
    const callbacks: Array<any> = [];
    this.newPartner = false;
    if (noErrors) {
      // Demand ID
      if (this.editMode && !this.duplicateMode) {
        demandToSave.vast_id = this.demandData.vastId;
      }
      // Settings
      demandToSave.vast_name = this.demandData.vast_name;
      demandToSave.vast_type = this.demandData.type;
      demandToSave.is_desktop = this.demandData.is_desktop ? 1 : 0;
      demandToSave.is_mobile_app = this.demandData.is_mobile_app ? 1 : 0;
      demandToSave.is_mobile_web = this.demandData.is_mobile_web ? 1 : 0;
      demandToSave.is_ctv = this.demandData.is_ctv ? 1 : 0;
      demandToSave.isMobile = demandToSave.is_mobile_app || demandToSave.is_mobile_web;
      demandToSave.premium = this.demandData.premium;
      if (!this.sharedService.isEmpty(this.demandData.partnerId)) {
        demandToSave.partnerID = this.demandData.partnerId;
      }
      if (!this.sharedService.isEmpty(this.demandData.partnerName)) {
        demandToSave.partnerName = this.demandData.partnerName;
        delete demandToSave.partnerID;
        this.newPartner = true;
      }
      if (
        this.demandData.vast_url &&
        this.demandData.vast_url.indexOf('http://') !== 0 &&
        this.demandData.vast_url.indexOf('https://') !== 0
      ) {
        this.demandData.vast_url = 'http://' + this.demandData.vast_url;
      }
      demandToSave.vast_url = this.demandData.type !== 3 ? this.demandData.vast_url : '';
      demandToSave.user_type = this.demandData.user_type;
      demandToSave.vast_cpm = this.demandData.vast_cpm;
      demandToSave.is_active = this.demandData.is_active;
      demandToSave.preroll = this.demandData.preroll;
      if (this.userService.getFeatureState('demand_first_ad_slot')) {
        demandToSave.first_ad_slot = this.demandData.first_ad_slot;
      }
      demandToSave.limit_assign = this.demandData.limitAssign;
      demandToSave.is_intent_demand = this.demandData.is_intent_demand;
      demandToSave.is_google_demand = this.demandData.is_google_demand;

      demandToSave.extra_params_enabled = this.demandData.extra_params_enabled;
      if (this.demandData.extra_params_enabled) {
        const extraParams = JSON.parse(this.demandData.extra_params);
        demandToSave.extra_params = stringify(extraParams);
      }

      demandToSave.premium = this.demandData.premium;
      demandToSave.allow_s2s = this.demandData.allow_s2s;
      demandToSave.rtb_vendor = this.demandData.rtb_vendor;
      demandToSave.deal_id = DemandService.setRTBDemandDealID(this.demandData.deal_id);
      demandToSave.floorCPM = this.demandData.floorCPM;
      demandToSave.parentNetworkId = this.demandData.parentNetworkId;
      if (this.demandData.type == 4) {
        demandToSave.bidder = {
          bidderId: this.demandData.bidder.bidderId,
          json: this.demandData.bidder.json,
        };
      }
      // Assigned Supply
      demandToSave.vast_players = this.assignedEntities;
      demandToSave.vast_players.forEach((assignedEntity: any) => {
        delete assignedEntity.$$selected;
      });

      // Targeting

      targeting.app_bundle_oper = !this.userService.getFeatureState('app_bundle_targeting_editable')
        ? 1
        : this.demandData.is_mobile_app
          ? this.demandData.targeting.app_bundle_oper
            ? 1
            : 0
          : 0;
      targeting.detected_domain_oper = !this.userService.getFeatureState('detected_domain_targeting_editable')
        ? 1
        : !!(this.demandData.is_desktop || this.demandData.is_mobile_web)
          ? this.demandData.targeting.detected_domain_oper
            ? 1
            : 0
          : 0;
      // Browsers
      targeting.browsers_oper = 0;
      targeting.browsers = '';
      if (this.targeting.browsers) {
        targeting.browsers_oper = this.demandData.targeting.browsers.type;
        for (let i = 0; i < this.demandData.targeting.browsers.list.length; i++) {
          targeting.browsers += (
            this.demandData.targeting.browsers.list[i].code +
            ':' +
            this.demandData.targeting.browsers.list[i].from +
            '-' +
            this.demandData.targeting.browsers.list[i].to
          ).toLowerCase();
          if (i + 1 < this.demandData.targeting.browsers.list.length) {
            targeting.browsers += ',';
          }
        }
      }
      // Categories
      targeting.categs_oper = 0;
      targeting.categs = '';
      // Countries
      targeting.country_codes_oper = 0;
      targeting.country_codes = '';
      if (this.targeting.location) {
        targeting.country_codes_oper = this.demandData.targeting.location.type;
        for (let i = 0; i < this.demandData.targeting.location.list.length; i++) {
          targeting.country_codes += this.demandData.targeting.location.list[i].iso;
          if (i + 1 < this.demandData.targeting.location.list.length) {
            targeting.country_codes += ',';
          }
        }
      }

      // IAS iasTargeting
      if (this.demandData.targeting.iasTargeting.list.length > 0) {
        targeting.iasTargeting_codes = this.extractIds(this.demandData.targeting.iasTargeting.list);
      }

      // Merge High risk with avoidance
      this.demandData.targeting.iasAvoidance.list.push(...this.demandData.targeting.highRiskAvoidance.list);
      // IAS iasAvoidance
      if (this.demandData.targeting.iasAvoidance.list.length > 0) {
        targeting.iasAvoidance_codes = this.extractIds(this.demandData.targeting.iasAvoidance.list);
      }

      // Environments
      targeting.envs_oper = targeting.envs === '' ? '0' : '1';
      targeting.envs = '';
      if (this.demandData.is_desktop) {
        targeting.envs += 'DK,';
      }
      if (this.demandData.is_mobile_web) {
        targeting.envs += 'MW,';
      }
      if (this.demandData.is_mobile_app) {
        targeting.envs += 'IA,';
      }
      if (this.demandData.is_ctv) {
        targeting.envs += 'CTV,';
      }
      targeting.envs = targeting.envs.length > 0 ? targeting.envs.substr(0, targeting.envs.length - 1) : '';
      // OS
      targeting.os_oper = 0;
      targeting.os = '';
      if (this.targeting.os) {
        targeting.os_oper = this.demandData.targeting.os.type;
        for (let i = 0; i < this.demandData.targeting.os.list.length; i++) {
          targeting.os += (
            this.demandData.targeting.os.list[i].code +
            ':' +
            this.demandData.targeting.os.list[i].from +
            '-' +
            this.demandData.targeting.os.list[i].to
          ).toLowerCase();
          if (i + 1 < this.demandData.targeting.os.list.length) {
            targeting.os += ',';
          }
        }
      }
      // Targeting demand ID
      targeting.vast_id = this.demandData.vastId;
      // Sizes
      targeting.sizes_oper = 0;
      targeting.sizes = '';
      targeting.sizes_ui = '';
      if (this.targeting.targetingSizes) {
        targeting.sizes = [];
        targeting.sizes_ui = [];
        targeting.sizes_oper = this.demandData.targeting.targetingSizes.type;
        for (let i = 0; i < this.demandData.targeting.targetingSizes.list.length; i++) {
          if (this.demandData.targeting.targetingSizes.list[i].targeting_playerSize_id) {
            targeting.sizes.push(this.demandData.targeting.targetingSizes.list[i].targeting_playerSize_id);
          } else {
            targeting.sizes.push(
              this.demandService.getCustomPlayerSizeId(
                this.demandData.targeting.targetingSizes.list[i].width,
                this.demandData.targeting.targetingSizes.list[i].height,
                this.demandData.targeting.targetingSizes.list[i].operator
              )
            );
            targeting.sizes_ui.push({
              n: this.demandData.targeting.targetingSizes.list[i].name,
              w: this.demandData.targeting.targetingSizes.list[i].width,
              h: this.demandData.targeting.targetingSizes.list[i].height,
              o: this.demandData.targeting.targetingSizes.list[i].operator,
            });
          }
        }
        targeting.sizes = targeting.sizes.join();
        targeting.sizes_ui = targeting.sizes_ui
          .map((size) => {
            return JSON.stringify(size);
          })
          .join('|');
      }
      // Black List Vendors
      targeting.vast_domains = '';
      targeting.vast_domains_oper = 0;
      if (this.targeting.vastDomains && this.demandData.targeting.vast_domains.list.length > 0) {
        targeting.vast_domains_oper = this.demandData.targeting.vast_domains.type;
        targeting.vast_domains = this.demandData.targeting.vast_domains.list.join(',');
      } else {
        this.demandData.targeting.vast_domains = this.demandService.demandModel.targeting.vast_domains;
        this.targeting.vastDomains = false;
      }
      // Viewability
      targeting.viewability = this.demandData.targeting.viewability;
      targeting.viewability_ispass = this.demandData.targeting.viewability_ispass;
      targeting.viewability_enabled = this.demandData.targeting.viewability_enabled;

      // IVT
      targeting.ivt = this.demandData.targeting.ivt;
      targeting.ivt_ispass = this.demandData.targeting.ivt_ispass;
      targeting.ivt_enabled = this.demandData.targeting.ivt_enabled;

      // DMA
      if (this.targeting.dma) {
        targeting.dma_oper = this.demandData.targeting.dma.type;
        targeting.dma = this.demandData.targeting.dma.list
          .map((dma) => {
            return dma.dma_id;
          })
          .join(',');
      } else {
        targeting.dma_oper = 0;
        targeting.dma = '';
      }
      // STATES
      if (this.targeting.state) {
        targeting.state_oper = this.demandData.targeting.state.type;
        targeting.state = this.demandData.targeting.state.list
          .map((state) => {
            return state.iso;
          })
          .join(',');
      } else {
        targeting.state_oper = 0;
        targeting.state = '';
      }
      // Schains
      if (this.targeting.schains && this.demandData.targeting.schains && this.demandData.targeting.schains.id) {
        targeting.schain_id = this.demandData.targeting.schains.id;
      } else {
        targeting.schain_id = '';
      }
      // Time Targeting
      if (this.demandData.targeting.time_targeting.list.length > 0) {
        targeting.time_targeting = _.map(this.demandData.targeting.time_targeting.list, (timeTargetingData) => {
          return this.stringifyTimeTargeting(timeTargetingData);
        }).join(',');
      } else {
        targeting.time_targeting = '';
      }
      // Targeting entry ID
      targeting.targeting_id = this.demandData.targeting.targeting_id;

      demandToSave.targeting = targeting;
      // Restrictions
      demandToSave.custom_mvr = this.demandData.custom_mvr ? 1 : 0;
      demandToSave.user_mvr = demandToSave.custom_mvr
        ? this.sharedService.parseNumeric(this.demandData.custom_user_mvr)
        : this.sharedService.parseNumeric(this.demandData.user_mvr);
      if (demandToSave.targeting.viewability_enabled) {
        demandToSave.targeting.viewability = this.sharedService.parseNumeric(this.demandData.targeting.viewability);
        demandToSave.targeting.viewability_ispass = this.sharedService.parseNumeric(
          this.demandData.targeting.viewability_ispass
        );
        demandToSave.targeting.viewability_enabled = 1;
      } else {
        demandToSave.targeting.viewability = 0;
        demandToSave.targeting.viewability_ispass = 0;
        demandToSave.targeting.viewability_enabled = 0;
      }
      if (demandToSave.targeting.ivt_enabled) {
        demandToSave.targeting.ivt = this.sharedService.parseNumeric(this.demandData.targeting.ivt);
        demandToSave.targeting.ivt_ispass = this.sharedService.parseNumeric(this.demandData.targeting.ivt_ispass);
        demandToSave.targeting.ivt_enabled = 1;
      } else {
        demandToSave.targeting.ivt = 0;
        demandToSave.targeting.ivt_ispass = 0;
        demandToSave.targeting.ivt_enabled = 0;
      }

      _.forEach(this.demandData.vast_capping, (value, key) => {
        let oneCap: any;

        if (!value.active) {
          return;
        } else {
          oneCap = _.cloneDeep(value);
          delete oneCap.active;
        }

        if (oneCap.cappingValue) {
          oneCap.cappingValue = oneCap.cappingValue.replace(/\D/g, '');
        } else {
          delete oneCap.cappingValue;
        }

        if ([3, 4].includes(oneCap.cappingType) || this.duplicateMode) {
          delete oneCap.id;
        }

        vast_capping[key] = oneCap;
      });

      demandToSave.vast_capping = vast_capping;
      demandToSave.domain_list_type = this.demandData.domainListType;
      if (demandToSave.domain_list_type !== 0) {
        for (let i = 0; i < this.demandData.domainLists.length; i++) {
          domainLists.push(+this.demandData.domainLists[i].id);
        }
      }
      demandToSave.domain_restriction_lists = domainLists;
      demandToSave.url_list_type = this.demandData.urlListType;
      if (demandToSave.url_list_type !== 0) {
        for (let i = 0; i < this.demandData.urlLists.length; i++) {
          urlLists.push(+this.demandData.urlLists[i].id);
        }
      }
      demandToSave.url_restriction_lists = urlLists;
      demandToSave.ip_list_type = this.demandData.ipListType;
      if (demandToSave.ip_list_type !== 0) {
        for (let i = 0; i < this.demandData.ipLists.length; i++) {
          ipLists.push(+this.demandData.ipLists[i].id);
        }
      }
      demandToSave.ip_restriction_lists = ipLists;
      demandToSave.should_rotate = !this.demandData.shouldRotate;
      demandToSave.filter_ivt = this.demandData.isPreBidSetGlobally
        ? this.demandData.filter_ivt
        : this.demandData.prebidFraud;

      // Callbacks
      for (let i = 0; i < this.demandData.callbacks.length; i++) {
        if (
          this.demandData.callbacks[i].url.indexOf('http://') !== 0 &&
          this.demandData.callbacks[i].url.indexOf('https://') !== 0
        ) {
          this.demandData.callbacks[i].url = 'http://' + this.demandData.callbacks[i].url;
        }
        callbacks.push({
          url: this.demandData.callbacks[i].url,
          eventId: this.demandData.callbacks[i].event.eventId,
          typeId: this.demandData.callbacks[i].event.typeId,
          rate: this.demandData.callbacks[i].rate,
        });
        if (this.demandData.callbacks[i].callbackId) {
          callbacks[i].callbackId = this.demandData.callbacks[i].callbackId;
        }
      }
      demandToSave.callbacks = callbacks;
      // Save the player
      this.isLoading = true;
      this.subscriptions.push(
        this.httpService.post('vdsp_ws/saveVast', demandToSave).subscribe((response: any) => {
          if (response) {
            if (response.status.toLowerCase() === 'ok') {
              this.demandData.vastId = response.vastId;
              this.userService.networkData.active_demands_limit_reached = response.limit_reached;
              this.beErrors = {};
              this.beErrorsArr = [];
              this.onSaveSuccess(close, response);
              if (close) {
                this.close();
              }
            } else if (response.errors && _.isObject(response.errors) && response.errors['active_supplies_limit']) {
              this.isLoading = false;
              this.sharedService.modalCedatoState = true;
              this.sharedService.modalCedatoHeader = 'WARNING';
              this.sharedService.modalCedatoBody = this.dictionaryService.get('LIMITS_NO_SAVE_MSG')('Demand');
              this.sharedService.modalCedatoButton = 'OK';
            } else {
              this.onSaveError(response.errors);
            }
          } else {
            this.onSaveError(response.errors);
          }
        })
      );
    }
    return noErrors;
  }

  close() {
    this.router.navigate(['/demand/manage']).then(() => {
      return;
    });
  }

  saveAndExit() {
    this.save(true);
  }

  /**
   * After creating a custom partner, sync it into the shared cache immediately so the
   * dropdown can show the name without waiting for a full page reload, then refresh
   * from the server in the background.
   */
  syncNewDemandPartner(response: any = null) {
    const partnerId =
      response && response.vast && !this.sharedService.isEmpty(response.vast.partnerId)
        ? +response.vast.partnerId
        : null;
    const partnerName = this.demandData.partnerName;

    if (partnerId && !this.sharedService.isEmpty(partnerName)) {
      const exists = _.some(this.sharedService.demandPartners, (p) => +p.partnerId === partnerId);
      if (!exists) {
        this.sharedService.demandPartners.push({ partnerId, name: partnerName });
        this.sharedService.demandPartners = _.orderBy(this.sharedService.demandPartners, 'name');
      }
      this.demandData.partnerId = partnerId;
      this.demandData.partnerName = null;
      this.resetPartners();
    }

    this.sharedService.sendMessage('NEW_DEMAND_PARTNER');
  }

  clearDemandPartnersRefresh() {
    if (this.demandPartnersRefreshTimeoutId != null) {
      clearTimeout(this.demandPartnersRefreshTimeoutId);
      this.demandPartnersRefreshTimeoutId = null;
    }
    if (this.demandPartnersRefreshSub) {
      this.demandPartnersRefreshSub.unsubscribe();
      this.demandPartnersRefreshSub = null;
    }
  }

  refreshDemandPartnersThen(done: () => void) {
    let finished = false;

    this.clearDemandPartnersRefresh();

    const finish = () => {
      if (finished) {
        return;
      }
      finished = true;
      this.clearDemandPartnersRefresh();
      this.resetPartners();
      done();
    };

    this.demandPartnersRefreshSub = this.sharedService.getMessagesBus().subscribe((message) => {
      if (message.type === 'DEMAND_PARTNERS_UPDATED') {
        finish();
      }
    });
    this.subscriptions.push(this.demandPartnersRefreshSub);

    // Safety net if DEMAND_PARTNERS_UPDATED never arrives (network/parse failure before emit)
    this.demandPartnersRefreshTimeoutId = setTimeout(finish, 10000);
  }

  onSaveSuccess(close: boolean = false, response: any = null) {
    if (this.editMode && !this.duplicateMode) {
      this.sharedService.showFlashMessage(this.dictionaryService.get('DEMAND_SAVED_SUCCESSFULLY'), 'success');
      if (this.newPartner) {
        this.syncNewDemandPartner(response);
        this.refreshDemandPartnersThen(() => {
          if (!close) {
            this.initializeDemandData();
          }
          this.isLoading = false;
        });
      } else {
        if (!close) {
          this.initializeDemandData();
        }
        this.isLoading = false;
      }
      this.originalData = _.cloneDeep(this.demandData);
    } else {
      this.sharedService.showFlashMessage(this.dictionaryService.get('DEMAND_CREATED_SUCCESSFULLY'), 'success');
      this.originalData = _.cloneDeep(this.demandData);
      const navigateToEditor = () => {
        this.router.navigate(['/demand/manage/', this.demandData.vastId]).then(() => {
          this.isLoading = false;
        });
      };
      if (this.newPartner) {
        this.syncNewDemandPartner(response);
        this.refreshDemandPartnersThen(navigateToEditor);
      } else {
        navigateToEditor();
      }
    }
  }

  onSaveError(errors: any = {}) {
    this.beErrors = errors;
    this.beErrorsArr = Object.keys(errors);
    this.sharedService.flashMessages = [];
    this.sharedService.flashMessagesIndex = 0;
    this.sharedService.showErrorFlashMessage(errors);
    this.isLoading = false;
  }

  onPremiumChange(premiumState) {
    // Check first if assigned to SupplyX
    // if Found  Make popup or error message
    this.demandData.premium = premiumState;
    // if (premiumState && this.hasSupplyXAssigned()) {
    //   this.demandData.premium = false;
    // }
  }

  updateIndexedAssignedEntities() {
    this.indexedAssignedEntities = this.sharedService.getIndexedArray(this.assignedEntities, 'playerId');
  }

  hasSupplyXAssigned(): boolean {
    let foundSupplyX = false;
    for (const supply of this.assignedSupplyData) {
      if (supply.type == 2 && supply.$$selected) {
        foundSupplyX = true;
        break;
      }
    }
    return foundSupplyX;
  }

  targetingTogglerChange(type: string): void {
    this.targeting[type] = !this.targeting[type];
    if (this.targeting[type] === false) {
      if (type === 'schains') {
        this.demandData.targeting[type] = null;
      } else {
        this.demandData.targeting[type].type = 0;
        this.demandData.targeting[type].list = [];
      }
    }
    if (['state', 'dma'].includes(type)) {
      if (type === 'state') {
        this.targeting.dma = false;
        this.demandData.targeting.dma.type = 0;
        this.demandData.targeting.dma.list = [];
      } else if (type === 'dma') {
        this.targeting.state = false;
        this.demandData.targeting.state.type = 0;
        this.demandData.targeting.state.list = [];
      }
    }
  }

  targetingIASTogglerChange(type: string): void {
    if (type === 'iasAvoidance') {
      const isAvoidingNewValue = !this.demandData.targeting.iasAvoidance.enabled;
      this.demandData.targeting.iasAvoidance.enabled = isAvoidingNewValue;
      if (!isAvoidingNewValue) {
        // if not Avoiding then empty all the list
        this.demandData.targeting.iasAvoidance.list = [];
        this.demandData.targeting.highRiskAvoidance.list = [];
      }
    } else if (type === 'iasTargeting') {
      const isTargetedNewValue = !this.demandData.targeting.iasTargeting.enabled;
      this.demandData.targeting.iasTargeting.enabled = isTargetedNewValue;
      if (!isTargetedNewValue) {
        // if not Targeting then empty all the list
        this.demandData.targeting.iasTargeting.list = [];
      }
    }
  }

  getCustomMVRMaxValue(type: number): void {
    this.customMVRCappingLimit = type === 3 ? 10 : 49;
  }

  formatExtraParams($event: any): void {
    if ($event && $event.Element && $event.Element.value && this.validateExtraParams()) {
      setTimeout(() => {
        this.demandData.extra_params = stringify(JSON.parse($event.srcElement.value), {
          space: this.sharedService.formatJSONstring,
        });
      }, 150);
    }
  }

  @HostListener('document:wheel', ['$event'])
  onScroll() {
    let found = false;
    let index = 0;
    const scrollY: number = window.scrollY;
    const sections: HTMLElement = document.getElementById('sections');
    let currSection: HTMLElement;
    if (sections) {
      while (!found && index < this.visibleSections.length - 1) {
        currSection = document.getElementById(this.visibleSections[index].value);
        if (currSection) {
          found = currSection.offsetTop >= scrollY;
        }
        if (!found) {
          index++;
        }
      }
    }

    this.activeSection =
      document.scrollingElement.scrollHeight - document.scrollingElement.scrollTop ===
      document.scrollingElement.clientHeight
        ? _.findIndex(this.allSections, { value: this.visibleSections[this.visibleSections.length - 1].value })
        : _.findIndex(this.allSections, { value: this.visibleSections[index].value });
  }

  parseExtraParams(paramsStr: string): object {
    try {
      return JSON.parse(paramsStr || '{}');
    } catch (error) {
      console.error('Could not parse extra params');
    }
  }

  updateExtraParams(params: object) {
    try {
      const parsed: any = this.parseExtraParams(this.demandData.extra_params || '{}');

      Object.entries(params).forEach(([key, value]) => {
        if (value === '' || value === null) {
          delete parsed[key];
        } else {
          parsed[key] = value;
        }
      });

      this.demandData.extra_params = stringify(parsed, {
        space: this.sharedService.formatJSONstring,
      });

      if (!this.demandData.extra_params_enabled) {
        this.demandData.extra_params_enabled = true;
      }
    } catch (error) {
      console.error('Could not update extra params');
    }
  }

  getDynamicDemandValue(paramsStr: string) {
    const parsed: any = this.parseExtraParams(paramsStr);

    this.dynamicDemand = parsed.dynamic_demand;
  }

  getPushPercentageValue(paramsStr: string) {
    const parsed: any = this.parseExtraParams(paramsStr);

    this.pushPercentage = parsed.push_percentage;
  }

  getMaxDurationValue(paramsStr: string) {
    const parsed: any = this.parseExtraParams(paramsStr);

    this.maxDuration = parsed.maxduration;
  }

  getGoogleKeyValueEnabled(paramsStr: string) {
    const parsed: any = this.parseExtraParams(paramsStr);

    this.googleKeyValueEnabled = parsed.gkv;
  }

  getGoogleKeyValueParam(paramsStr: string) {
    const parsed: any = this.parseExtraParams(paramsStr);

    this.googleKeyValueParam = parsed.gkvp;
  }

  getDemandSubType(paramsStr: string) {
    const parsed: any = this.parseExtraParams(paramsStr);

    this.demandSubType = parsed.demand_sub_type;
  }

  getDemandGoogleSlotId(paramsStr: string) {
    const parsed: any = this.parseExtraParams(paramsStr);

    this.googleSlotId = parsed.googleSlotId;
  }

  getDemandGoogleSlotDimensions(paramsStr: string) {
    const parsed: any = this.parseExtraParams(paramsStr);

    try {
      const dimensions = JSON.stringify(parsed.googleSlotDimensions);
      this.googleSlotDimensions = dimensions;
    } catch (err) {}
  }

  getDemandDisplayFallback(paramsStr: string) {
    const parsed: any = this.parseExtraParams(paramsStr);

    this.demandDisplayFallback = parsed.demand_display_fallback;
  }

  getExperimentalFeatures(paramsStr: string) {
    const parsed: any = this.parseExtraParams(paramsStr);

    Object.keys(this.experimentalFeatures).forEach((feature: string) => {
      if (parsed[feature] !== undefined) {
        this.experimentalFeatures[feature] = parsed[feature];
      }
    });
  }

  onGoogleKeyValueToggle() {
    this.googleKeyValueEnabled = !this.googleKeyValueEnabled;

    this.updateExtraParams({ gkv: this.googleKeyValueEnabled });
  }

  onGoogleKeyValueParamChange() {
    this.updateExtraParams({ gkvp: this.googleKeyValueParam });
  }

  onDemandDisplayFallbackChange() {
    this.demandDisplayFallback = !this.demandDisplayFallback;

    this.updateExtraParams({ demand_display_fallback: this.demandDisplayFallback });
  }

  onDemandGoogleSlotDimensionsChange() {
    try {
      const dimensions = JSON.parse(this.googleSlotDimensions);
      this.updateExtraParams({ googleSlotDimensions: dimensions });
    } catch (err) {}
  }

  onDemandGoogleSlotIdChange() {
    this.updateExtraParams({ googleSlotId: this.googleSlotId });
  }

  toggleDynamicDemandValue() {
    this.dynamicDemand = !this.dynamicDemand;

    this.updateExtraParams({ dynamic_demand: this.dynamicDemand });
  }

  onPushPercentageChange() {
    this.updateExtraParams({ push_percentage: this.pushPercentage });
  }

  onMaxDurationChange() {
    this.updateExtraParams({ maxduration: this.maxDuration });
  }

  toggleExperimentalFeature(feature: string) {
    this.experimentalFeatures[feature] = !this.experimentalFeatures[feature];

    this.updateExtraParams(this.experimentalFeatures);
  }

  editExperimentalFeatures(feature: string, value: any) {
    if (['maxImp', 'maxReq', 'playCapInSlot', 'gapInSlot'].includes(feature)) {
      this.experimentalFeatures[feature] = Math.round(Math.abs(value)) || null;
    } else {
      this.experimentalFeatures[feature] = value;
    }

    this.updateExtraParams(this.experimentalFeatures);
  }

  setExperimentalFeaturePreset(state: boolean, feature: string) {
    this.experimentalFeatures[feature] = state;
    const featurePreset = FEATURES_PRESETS[feature];

    if (featurePreset) {
      if (state) {
        this.experimentalFeatures[featurePreset.feature] = Object.assign(
          {},
          this.experimentalFeatures[featurePreset.feature],
          featurePreset.preset || {}
        );
      } else {
        for (const featureElement of Object.keys(featurePreset.preset)) {
          delete this.experimentalFeatures[featurePreset.feature][featureElement];
        }

        if (Object.keys(this.experimentalFeatures[featurePreset.feature]).length === 0) {
          this.experimentalFeatures[featurePreset.feature] = undefined;
        }
      }

      this.updateExtraParams(this.experimentalFeatures);
    }
  }

  onMaxImpToggleChange() {
    this.isMaxImpActive = !this.isMaxImpActive;
    if (!this.isMaxImpActive) {
      this.experimentalFeatures.maxImp = null;
      this.updateExtraParams(this.experimentalFeatures);
    }
  }

  onMaxReqToggleChange() {
    this.isMaxReqActive = !this.isMaxReqActive;
    if (!this.isMaxReqActive) {
      this.experimentalFeatures.maxReq = null;
      this.updateExtraParams(this.experimentalFeatures);
    }
  }

  onPlayCapInSlotToggleChange() {
    this.isPlayCapInSlotActive = !this.isPlayCapInSlotActive;
    if (!this.isPlayCapInSlotActive) {
      this.experimentalFeatures.playCapInSlot = null;
      this.updateExtraParams(this.experimentalFeatures);
    }
  }

  onGapInSlotToggleChange() {
    this.isGapInSlotActive = !this.isGapInSlotActive;
    if (!this.isGapInSlotActive) {
      this.experimentalFeatures.gapInSlot = null;
      this.updateExtraParams(this.experimentalFeatures);
    }
  }

  onAdSlotTargetedToggleChange(event) {
    if (!this.experimentalFeatures.slotTypeTargeting) {
      this.experimentalFeatures.slotTypeTargeting = { enable: false, list: [] };
    }
    this.adSlotTargeting = event;
    this.experimentalFeatures.slotTypeTargeting.enable = this.adSlotTargeting;
    this.updateExtraParams(this.experimentalFeatures);
  }

  onAdSlotTargetingChange() {
    if (!this.experimentalFeatures.slotTypeTargeting) {
      this.experimentalFeatures.slotTypeTargeting = { enable: false, list: [] };
    }
    this.experimentalFeatures.slotTypeTargeting.list = this.adSlotsTargetingList.map((adSlot) => adSlot.code);
    this.updateExtraParams(this.experimentalFeatures);
  }

  onGoogleMacrosChange(event: boolean) {
    this.experimentalFeatures.disableGoogleMacros = event;
    this.updateExtraParams(this.experimentalFeatures);
  }

  /**
   * Updates demand-level `googleMacroSuppression` (e.g. `{ vpmute: 10 }` = strip vpmute on 10% of requests).
   * Empty / cleared / 0 macros are omitted; empty object is stored as null so the extra param is removed.
   */
  onGoogleMacroSuppressionChange(macro: 'vpmute' | 'plcmt' | 'vpa', value: number | string) {
    const current = { ...(this.experimentalFeatures.googleMacroSuppression || {}) };

    if (value === '' || value === null || value === undefined) {
      delete current[macro];
    } else {
      const num = Math.round(Number(value));
      // NaN or 0 = no suppression for this macro → omit from payload
      if (Number.isNaN(num) || num === 0) {
        delete current[macro];
      } else {
        current[macro] = num;
      }
    }

    this.experimentalFeatures.googleMacroSuppression = Object.keys(current).length ? current : null;
    this.errorInputs = _.without(this.errorInputs, 'googleMacroSuppression');
    this.updateExtraParams(this.experimentalFeatures);
  }

  /** True when any configured macro suppression % is outside 0–100. */
  isGoogleMacroSuppressionInvalid(): boolean {
    const suppression = this.experimentalFeatures.googleMacroSuppression;
    if (!suppression) {
      return false;
    }
    return Object.keys(suppression).some((key) => {
      const v = suppression[key];
      return v !== null && v !== undefined && (v < 0 || v > 100);
    });
  }

  onSchainOverrideChange(change: 'enabled' | 'asi' | 'sid', value: never) {
    if (!this.experimentalFeatures.scho) {
      this.experimentalFeatures.scho = { enabled: false, asi: '', sid: '' };
    }

    this.experimentalFeatures.scho[change] = value;
    this.updateExtraParams(this.experimentalFeatures);
  }

  onSchainAdditionChange(change: 'enabled' | 'asi' | 'sid', value: never) {
    if (!this.experimentalFeatures.scha) {
      this.experimentalFeatures.scha = { enabled: false, asi: '', sid: '' };
    }

    this.experimentalFeatures.scha[change] = value;
    this.updateExtraParams(this.experimentalFeatures);
  }

  onDemandSessionChange(change: 'enabled' | 'maxImpressions', value: never) {
    if (!this.experimentalFeatures.demandCap) {
      this.experimentalFeatures.demandCap = { enabled: false, maxImpressions: 1 };
    }
    if (change === 'maxImpressions' && value < 1 && value !== 0) {
      return;
    }

    this.experimentalFeatures.demandCap[change] = value;
    this.updateExtraParams(this.experimentalFeatures);
  }

  onToggleChane(value: boolean, key) {
    this.experimentalFeatures[key] = value;
    this.updateExtraParams(this.experimentalFeatures);
  }

  onExternalDynamicVastChange(value: boolean) {
    this.experimentalFeatures.externalDynamicVast = value;
    this.updateExtraParams(this.experimentalFeatures);
  }

  onInputChane(value: never, key: string) {
    if (value < 0) {
      return;
    }
    this.experimentalFeatures[key] = value;
    this.updateExtraParams(this.experimentalFeatures);
  }

  onPrebidServerChange(value) {
    this.experimentalFeatures.pbserver = value;
    if (!value) {
      this.experimentalFeatures.pbsStoredRequestId = '';
    }
    this.updateExtraParams(this.experimentalFeatures);
    if (!this.experimentalFeatures.pbserver) {
      this.experimentalFeatures.pbserverParams = {};
    }
    if (this.demandData.type === 4 && this.demandData.bidder.bidderId === APPNEXUS_PREBID_BIDDER_ID) {
      this.demandData.bidder.json = this.migrateAppNexusBidderJson(this.demandData.bidder.json || '{}');
      const bidderItem = _.find(this.demandService.bidders, { value: APPNEXUS_PREBID_BIDDER_ID });
      if (bidderItem) {
        this.fillBidderConf(bidderItem);
      }
    }
  }

  isAssertiveYieldBidder() {
    return this.demandData.bidder.bidderId === ASSERTIVE_YIELD_PREBID_BIDDER_ID;
  }

  onPbsStoredRequestIdChange(event) {
    this.experimentalFeatures.pbsStoredRequestId = event.target.value.trim();
    this.updateExtraParams(this.experimentalFeatures);
  }

  isBidderOnPrebidServer() {
    return !!this.prebidServerParams.bidders.find((bidder) => bidder.id === this.demandData.bidder.bidderId);
  }

  getPrebidServerBidder() {
    if (this.prebidServerParams.bidders.find((bidder) => bidder.id === this.demandData.bidder.bidderId)) {
      return this.prebidServerParams.bidders.find((bidder) => bidder.id === this.demandData.bidder.bidderId);
    }
    return { params: [] };
  }

  onPbjsOptionalParamsChange(val: object) {
    this.experimentalFeatures.pbjsOptionalParams = val;
    this.updateExtraParams(this.experimentalFeatures);
  }

  onPrebidServerParamChange(event, name, type) {
    if (this.experimentalFeatures.pbserver) {
      if (type === 'string') {
        this.experimentalFeatures.pbserverParams[name] = event.target.value;
      } else {
        try {
          this.experimentalFeatures.pbserverParams[name] = parseInt(event.target.value, 10);
        } catch (e) {
          this.experimentalFeatures.pbserverParams[name] = 0;
        }
      }

      this.updateExtraParams(this.experimentalFeatures);
    } else {
      this.experimentalFeatures.pbserverParams = {};
      this.updateExtraParams(this.experimentalFeatures);
    }
  }

  onPrebidOemSchainParams(event, feat, type) {
    if (this.experimentalFeatures[feat]) {
      this.experimentalFeatures[feat][type] = event.target.value;
      this.updateExtraParams(this.experimentalFeatures);
    } else {
      this.experimentalFeatures[feat] = {};
      this.experimentalFeatures[feat][type] = event.target.value;
      this.updateExtraParams(this.experimentalFeatures);
    }
  }

  onPrebidOemPlacementParams(event, feat, type) {
    if (this.experimentalFeatures[feat]) {
      this.experimentalFeatures[feat][type] = event.value;
      this.selectedPlacement[type] = event.value;
      this.updateExtraParams(this.experimentalFeatures);
    } else {
      this.experimentalFeatures[feat] = {};
      this.experimentalFeatures[feat][type] = event.value;
      this.selectedPlacement[type] = event.value;
      this.updateExtraParams(this.experimentalFeatures);
    }
  }

  getSelectedPlacementIndex(type: string) {
    return this.placements[type].findIndex((placement) => placement.value === this.experimentalFeatures.plcmtOem[type]);
  }

  getSelectedSchainOptionIndex() {
    const extra = this.experimentalFeatures || {};

    if (extra.dntssch) {
      this.schainDropDownValue = 'dntssch';
      return 0;
    }
    if (extra.scho && extra.scho.enabled) {
      this.schainDropDownValue = 'scho';
      return 1;
    }
    if (extra.scha && extra.scha.enabled) {
      this.schainDropDownValue = 'scha';
      return 2;
    }
    if (extra.keepHardCodedSchain) {
      this.schainDropDownValue = 'keepHardCodedSchain';
      return 3;
    }

    return -1;
  }

  onSchainOptionChange(event) {
    if (!event) {
      this.experimentalFeatures.scho = null;
      this.experimentalFeatures.scha = null;
      this.experimentalFeatures.dntssch = null;
      this.experimentalFeatures.keepHardCodedSchain = null;
      this.schainDropDownValue = '';
    } else {
      if (event.value === 'scho') {
        this.experimentalFeatures.scho = { enabled: true, asi: '', sid: '' };
        this.experimentalFeatures.scha = null;
        this.experimentalFeatures.dntssch = null;
        this.experimentalFeatures.keepHardCodedSchain = null;
      } else if (event.value === 'scha') {
        this.experimentalFeatures.scha = { enabled: true, asi: '', sid: '' };
        this.experimentalFeatures.scho = null;
        this.experimentalFeatures.dntssch = null;
        this.experimentalFeatures.keepHardCodedSchain = null;
      } else {
        this.experimentalFeatures.scho = null;
        this.experimentalFeatures.scha = null;
        this.experimentalFeatures.keepHardCodedSchain = null;
        this.experimentalFeatures.dntssch = null;
        this.experimentalFeatures[event.value] = true;
      }

      this.schainDropDownValue = event.value;
    }

    this.updateExtraParams(this.experimentalFeatures);
  }

  isDisplay() {
    return this.demandSubType === TYPE_DISPLAY;
  }

  isPartner(partnerName: string) {
    return (this.getPartnerName() || '').toLowerCase().includes(partnerName.toLowerCase());
  }

  isGoogleDisplay() {
    return this.isPartner('google') && this.isDisplay();
  }
}
